(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["crystal-personalizer"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const init = (root) => {
      if (!root || root.dataset.ready === 'true') return;
      root.dataset.ready = 'true';
      const strings = {
        add: root.dataset.labelAdd || 'Add',
        added: root.dataset.labelAdded || 'Added',
        awaitingConfiguration: root.dataset.labelAwaitingConfiguration || 'Awaiting product setup',
        addToCart: root.dataset.labelAddToCart || 'Add to cart',
        buyNow: root.dataset.labelBuyNow || 'Buy now',
        adding: root.dataset.labelAdding || 'Adding…',
        checkingOut: root.dataset.labelCheckingOut || 'Preparing checkout…',
        addedToCart: root.dataset.labelAddedToCart || 'Added to cart',
        selectedVariant: root.dataset.labelSelectedVariant || 'Selected option',
        photoRequired: root.dataset.errorPhotoRequired || 'Please upload a photo before adding to cart.',
        fileTooLarge: root.dataset.errorFileTooLarge || 'Please choose an image smaller than 15 MB.',
        fileType: root.dataset.errorFileType || 'Please choose a JPG, PNG, or WEBP image.',
        cartError: root.dataset.errorCart || 'We could not add this configuration. Please try again.',
        partialCartError: root.dataset.errorPartialCart || 'The main item was added, but one or more add-ons could not be added. Please review your cart.',
        unavailable: root.dataset.labelUnavailable || 'Unavailable'
      };
      const form = root.querySelector('.cp__form');
      const preview = root.querySelector('[data-cp-preview]');
      const placeholder = root.querySelector('[data-preview-placeholder]');
      const photoInput = root.querySelector('[data-photo-input]');
      const photoName = root.querySelector('[data-photo-name]');
      const editPhotoButton = root.querySelector('[data-edit-photo]');
      const composite = root.querySelector('[data-composite]');
      const compositeConfigNode = root.querySelector('[data-composite-assets]');
      const accessoryConfigNode = root.querySelector('[data-accessory-product-data]');
      const accessoryEditorAssetsNode = root.querySelector('[data-accessory-editor-assets]');
      let compositeConfig = null;
      let accessoryConfig = null;
      let accessoryEditorAssets = {};
      try {
        compositeConfig = compositeConfigNode ? JSON.parse(compositeConfigNode.textContent || 'null') : null;
      } catch (error) {
        compositeConfig = null;
      }
      try {
        accessoryConfig = accessoryConfigNode ? JSON.parse(accessoryConfigNode.textContent || 'null') : null;
      } catch (error) {
        accessoryConfig = null;
      }
      try {
        accessoryEditorAssets = accessoryEditorAssetsNode ? JSON.parse(accessoryEditorAssetsNode.textContent || '{}') : {};
      } catch (error) {
        accessoryEditorAssets = {};
      }
      const editorPhoto = root.querySelector('[data-editor-photo]');
      const isComposite = Boolean(composite && compositeConfig?.assets);
      const accessoryProducts = accessoryConfig?.products || {};
      let accessoryKey = accessoryConfig?.defaultKey || '';
      let activeAccessory = accessoryProducts[accessoryKey] || null;
      let personalizerProfile = activeAccessory?.profile || root.dataset.personalizerProfile || 'default';
      const variantInput = root.querySelector('[data-main-variant]');
      const configurationInput = root.querySelector('[data-configuration-id]');
      const selectedOptionsProperty = root.querySelector('[data-selected-options-property]');
      const personalizerProfileProperty = root.querySelector('[data-personalizer-profile-property]');
      const accessoryProductProperty = root.querySelector('[data-accessory-product-property]');
      const previewLayoutProperty = root.querySelector('[data-preview-layout-property]');
      const photoFitProperty = root.querySelector('[data-photo-fit-property]');
      const selectedVariantLabel = root.querySelector('[data-selected-variant]');
      const backLink = root.querySelector('.cp__back');
      const status = root.querySelector('[data-status]');
      const variantData = root.querySelector('[data-variant-data]');
      const variants = variantData ? JSON.parse(variantData.textContent || '[]') : [];
      const currency = root.dataset.currency || 'USD';
      const routesRoot = window.Shopify?.routes?.root || '/';
      const editParams = new URLSearchParams(window.location.search);
      const performanceDebug = editParams.get('ag_perf') === '1';
      const editConfigurationId = editParams.get('ag_edit') || '';
      const isFullEdit = editParams.get('ag_mode') === 'full' && Boolean(editConfigurationId);
      const cartActionLabel = isFullEdit ? 'Save changes' : strings.addToCart;
      const checkoutActionLabel = isFullEdit ? 'Save & checkout' : strings.buyNow;
      const cartBusyLabel = isFullEdit ? 'Saving…' : strings.adding;
      const checkoutBusyLabel = isFullEdit ? 'Saving…' : strings.checkingOut;
      let editSnapshot = null;
      let editRestoreReady = !isFullEdit;
      if (isFullEdit) {
        try {
          editSnapshot = JSON.parse(sessionStorage.getItem(`ag-full-edit:${editConfigurationId}`) || 'null');
          if (editSnapshot?.configurationId !== editConfigurationId) editSnapshot = null;
        } catch (error) {
          editSnapshot = null;
        }
        if (backLink) backLink.href = `${routesRoot}cart`;
        root.querySelectorAll('[data-purchase-button]').forEach((button) => {
          const label = button.querySelector('span');
          if (label) label.textContent = button.dataset.cartAction === 'checkout' ? checkoutActionLabel : cartActionLabel;
          button.setAttribute('aria-label', button.dataset.cartAction === 'checkout' ? checkoutActionLabel : cartActionLabel);
          button.disabled = true;
        });
        root.setAttribute('aria-busy', 'true');
      }
      let objectUrl = '';
      let restoredPhotoSource = '';
      let zoom = 100;
      let rotation = 0;
      let photoX = 0;
      let photoY = 0;
      let photoFit = 'fit';
      let photoNaturalWidth = 0;
      let photoNaturalHeight = 0;
      let activeMaskSource = '';
      let activeMaskBounds = { left: 0, top: 0, right: 1, bottom: 1 };
      const maskBoundsCache = new Map();
      const decodedImageCache = new Map();
      let adjustedPreviewCache = { signature: '', file: null, promise: null };
      let adjustedPreviewGeneration = 0;
      let adjustedPreviewWarmupTimer = 0;
      let dialogSnapshot = null;
      let busy = false;
      let dimensionUnit = 'in';
      let compositeAssetKey = compositeConfig?.defaultKey || 'default';
      let engravingPositionTouched = false;
      let cartPerformanceRun = null;
      const clamp = (value, min, max) => Math.min(max, Math.max(min, value));

      const snapshotItem = (item) => ({
        key: item.key,
        variant_id: item.variant_id,
        quantity: item.quantity,
        product_id: item.product_id,
        product_type: item.product_type,
        properties: item.properties || {}
      });
      const loadEditSnapshot = async () => {
        if (!isFullEdit) return null;
        const cachedSnapshot = editSnapshot;
        try {
          const response = await fetch(`${routesRoot}cart.js`, {
            headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }
          });
          if (!response.ok) throw new Error('cart-snapshot');
          const cart = await response.json();
          const items = (cart.items || [])
            .filter((item) => item.properties?.['_Configuration ID'] === editConfigurationId || item.key === editConfigurationId)
            .map(snapshotItem);
          const main = items.find((item) => !item.properties?.['_Item type']);
          if (!main) return null;
          const liveSnapshot = {
            configurationId: editConfigurationId,
            originalVariantId: main.variant_id || null,
            items,
            createdAt: Date.now()
          };
          try {
            sessionStorage.setItem(`ag-full-edit:${editConfigurationId}`, JSON.stringify(liveSnapshot));
          } catch (error) {
            // The live cart remains authoritative when browser storage is unavailable.
          }
          return liveSnapshot;
        } catch (error) {
          return cachedSnapshot?.items?.length ? cachedSnapshot : null;
        }
      };

      const formatMoney = (cents) => new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency }).format((Number(cents) || 0) / 100);
      const formatDimensionValue = (millimetres, unit) => {
        const value = Number(millimetres);
        if (!Number.isFinite(value)) return '';
        if (unit === 'in') return (value / 25.4).toFixed(2);
        return Number.isInteger(value) ? value.toFixed(0) : value.toFixed(2).replace(/\.00$/, '').replace(/(\.\d)0$/, '$1');
      };
      const renderDimensions = (nodes = root.querySelectorAll('[data-dimensions]')) => {
        [...nodes].forEach((node) => {
          const parts = [
            ['widthMm', 'W'],
            ['depthMm', 'D'],
            ['heightMm', 'H']
          ].flatMap(([key, label]) => {
            const value = node.dataset[key];
            return value == null || value === '' ? [] : [`${label} ${formatDimensionValue(value, dimensionUnit)}`];
          });
          node.hidden = parts.length === 0;
          node.textContent = parts.length ? `${parts.join(' × ')} ${dimensionUnit}` : '';
        });
      };
      const setDimensionUnit = (unit) => {
        dimensionUnit = unit === 'mm' ? 'mm' : 'in';
        root.querySelectorAll('[data-dimension-unit]').forEach((button) => {
          const selected = button.dataset.dimensionUnit === dimensionUnit;
          button.classList.toggle('is-active', selected);
          button.setAttribute('aria-pressed', String(selected));
        });
        renderDimensions();
      };
      const optionCount = variants.reduce((count, variant) => Math.max(count, variant.options?.length || 0), 0);
      const lowStockThreshold = Number(root.dataset.lowStockThreshold || 5);
      const optionInputs = () => [...root.querySelectorAll('[data-product-option]:checked, [data-fixed-product-option]')]
        .sort((a, b) => Number(a.dataset.optionPosition) - Number(b.dataset.optionPosition));
      const selectedOptionValues = () => {
        const selected = Array(optionCount).fill(null);
        optionInputs().forEach((input) => { selected[Number(input.dataset.optionPosition) - 1] = input.value; });
        return selected;
      };
      const selectedExtras = () => [...root.querySelectorAll('[data-feature]:checked, [data-addon].is-selected')]
        .filter((node) => node.dataset.configured === 'true' && node.dataset.available !== 'false');

      const findVariant = (selected) => variants.find((variant) => selected.every((value, index) => !value || String(variant.options?.[index] || '') === String(value))) || null;

      const resolveVariant = () => {
        if (activeAccessory?.variant?.id) return activeAccessory.variant;
        if (!variants.length) return null;
        const selected = selectedOptionValues();
        if (selected.some(Boolean)) return findVariant(selected);
        return variants.find((variant) => String(variant.id) === String(variantInput?.value || '')) || variants.find((variant) => variant.available) || variants[0];
      };

      const updateSizeCards = () => {
        const sizeGroup = root.querySelector('.cp__sizes[data-option-position]');
        if (!sizeGroup) return;
        const sizePosition = Number(sizeGroup.dataset.optionPosition) - 1;
        root.querySelectorAll('[data-size-card]').forEach((card) => {
          const selected = selectedOptionValues();
          selected[sizePosition] = card.dataset.sizeValue;
          const variant = findVariant(selected);
          const input = card.querySelector('[data-product-option]');
          const available = Boolean(variant?.available);
          if (input) input.disabled = !available;
          card.classList.toggle('is-unavailable', !available);

          const price = Number(variant?.price || 0);
          const compare = Number(variant?.compare_at_price || 0);
          const sale = compare > price && compare > 0;
          const discount = sale ? Math.round(((compare - price) / compare) * 100) : 0;
          const priceNode = card.querySelector('[data-size-price]');
          const compareNode = card.querySelector('[data-size-compare]');
          const discountNode = card.querySelector('[data-size-discount]');
          if (priceNode) priceNode.textContent = formatMoney(price);
          if (compareNode) {
            compareNode.hidden = !sale;
            compareNode.textContent = sale ? formatMoney(compare) : '';
          }
          if (discountNode) {
            discountNode.hidden = !discount;
            discountNode.textContent = discount ? `${discount}% OFF` : '';
          }

          const dimensionsNode = card.querySelector('[data-size-dimensions]');
          if (dimensionsNode) {
            const width = variant?.size_width_mm;
            const depth = variant?.size_depth_mm;
            const height = variant?.size_height_mm;
            if (width == null || width === '') delete dimensionsNode.dataset.widthMm;
            else dimensionsNode.dataset.widthMm = width;
            if (depth == null || depth === '') delete dimensionsNode.dataset.depthMm;
            else dimensionsNode.dataset.depthMm = depth;
            if (height == null || height === '') delete dimensionsNode.dataset.heightMm;
            else dimensionsNode.dataset.heightMm = height;
            renderDimensions([dimensionsNode]);
          }

          const peopleNode = card.querySelector('[data-size-people]');
          const peopleLabel = peopleNode?.querySelector('small');
          const peopleMin = variant?.people_min;
          const peopleMax = variant?.people_max;
          if (peopleNode) peopleNode.hidden = peopleMin == null && peopleMax == null;
          if (peopleLabel) peopleLabel.textContent = peopleMin == null ? '' : `${peopleMin}${peopleMax != null && String(peopleMax) !== String(peopleMin) ? `–${peopleMax}` : ''}`;

          const bestNode = card.querySelector('[data-size-best]');
          if (bestNode) bestNode.hidden = !variant?.best_seller;
          const stockNode = card.querySelector('[data-size-stock]');
          if (stockNode) {
            const isOut = !available;
            const isLow = available && variant?.inventory_managed && Number(variant.inventory_quantity) > 0 && Number(variant.inventory_quantity) <= lowStockThreshold;
            stockNode.hidden = !isOut && !isLow;
            stockNode.textContent = isOut ? 'OUT OF STOCK' : isLow ? 'LOW STOCK' : '';
            stockNode.classList.toggle('is-out', isOut);
            stockNode.classList.toggle('is-low', isLow);
          }
        });
      };

      const syncOptionAvailability = () => {
        const groups = [...root.querySelectorAll('[data-option-group]')];
        groups.forEach((group) => {
          const position = Number(group.dataset.optionPosition) - 1;
          group.querySelectorAll('[data-product-option]').forEach((input) => {
            const candidate = selectedOptionValues();
            candidate[position] = input.value;
            const candidateAvailable = variants.some((variant) => variant.available && candidate.every((value, index) => !value || String(variant.options?.[index] || '') === value));
            input.disabled = !candidateAvailable && !input.checked;
          });
        });
      };

      const normalizeCompositeKey = (value) => String(value || '')
        .trim()
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, '');

      const readMaskBounds = (src) => {
        if (!src) return Promise.resolve({ left: 0, top: 0, right: 1, bottom: 1 });
        if (maskBoundsCache.has(src)) return maskBoundsCache.get(src);
        const request = new Promise((resolve) => {
          const image = new Image();
          image.crossOrigin = 'anonymous';
          image.addEventListener('load', () => {
            try {
              const canvas = document.createElement('canvas');
              canvas.width = image.naturalWidth || 1000;
              canvas.height = image.naturalHeight || 1000;
              const context = canvas.getContext('2d', { willReadFrequently: true });
              context.drawImage(image, 0, 0, canvas.width, canvas.height);
              const pixels = context.getImageData(0, 0, canvas.width, canvas.height).data;
              let minX = canvas.width;
              let minY = canvas.height;
              let maxX = -1;
              let maxY = -1;
              for (let y = 0; y < canvas.height; y += 1) {
                for (let x = 0; x < canvas.width; x += 1) {
                  if (pixels[((y * canvas.width) + x) * 4 + 3] <= 24) continue;
                  minX = Math.min(minX, x);
                  minY = Math.min(minY, y);
                  maxX = Math.max(maxX, x);
                  maxY = Math.max(maxY, y);
                }
              }
              if (maxX < minX || maxY < minY) throw new Error('empty-mask');
              resolve({
                left: minX / canvas.width,
                top: minY / canvas.height,
                right: (maxX + 1) / canvas.width,
                bottom: (maxY + 1) / canvas.height
              });
            } catch (error) {
              resolve({ left: 0, top: 0, right: 1, bottom: 1 });
            }
          }, { once: true });
          image.addEventListener('error', () => resolve({ left: 0, top: 0, right: 1, bottom: 1 }), { once: true });
          image.src = src;
        });
        maskBoundsCache.set(src, request);
        return request;
      };

      const setCompositeAsset = (key) => {
        if (!isComposite) return;
        const nextKey = compositeConfig.assets[key] ? key : compositeConfig.defaultKey;
        const asset = compositeConfig.assets[nextKey] || compositeConfig.assets.default;
        if (!asset) return;
        compositeAssetKey = nextKey;
        root.querySelectorAll('[data-composite-base]').forEach((image) => {
          if (image.getAttribute('src') !== asset.base) image.src = asset.base;
        });
        root.querySelectorAll('[data-composite-overlay]').forEach((image) => {
          if (image.getAttribute('src') !== asset.overlay) image.src = asset.overlay;
        });
        root.querySelectorAll('[data-composite-photo-window]').forEach((windowNode) => {
          windowNode.style.setProperty('--cp-photo-mask', `url("${asset.mask}")`);
        });
        composite.dataset.compositeKey = nextKey;
        composite.dataset.compositeBaseSrc = asset.base;
        composite.dataset.compositeMaskSrc = asset.mask;
        composite.dataset.compositeOverlaySrc = asset.overlay;
        activeMaskSource = asset.mask;
        readMaskBounds(asset.mask).then((bounds) => {
          if (activeMaskSource !== asset.mask) return;
          activeMaskBounds = bounds;
          if (accessoryConfig && !engravingPositionTouched) {
            const engravingCenterX = (((bounds.left + bounds.right) / 2) - .5) * 100;
            const engravingCenterY = (((bounds.top + bounds.bottom) / 2) - .5) * 100;
            const engravingXNode = root.querySelector('[data-engraving-x]');
            const engravingYNode = root.querySelector('[data-engraving-y]');
            if (engravingXNode) engravingXNode.value = String(Math.round(clamp(engravingCenterX, -38, 38)));
            if (engravingYNode) engravingYNode.value = String(Math.round(clamp(engravingCenterY, -38, 38)));
            updateEngravingPreview();
          }
          if (photoFit === 'fill' && photoNaturalWidth && photoNaturalHeight) updateImageTransform();
        });
        if (previewLayoutProperty) previewLayoutProperty.value = nextKey;
        root.querySelectorAll('[data-composite-layout]').forEach((button) => {
          button.setAttribute('aria-pressed', String(button.dataset.compositeLayout === nextKey));
        });
        warmCompositeAssets(asset);
        invalidateAdjustedPreview();
      };
      const syncCompositeForVariant = (variant) => {
        if (!isComposite || compositeConfig.mode !== 'variant' || !variant) return;
        const mappedKey = compositeConfig.variantKeys?.[normalizeCompositeKey(variant.title)];
        if (mappedKey) setCompositeAsset(mappedKey);
      };
      const detectCompositeOrientation = async (file) => {
        if (!isComposite || !file) return;
        try {
          const source = window.createImageBitmap ? await createImageBitmap(file) : await loadImageSource(objectUrl);
          photoNaturalWidth = source.width || source.naturalWidth || 0;
          photoNaturalHeight = source.height || source.naturalHeight || 0;
          if (compositeConfig.mode === 'orientation') {
            setCompositeAsset(photoNaturalWidth > photoNaturalHeight ? 'landscape' : 'portrait');
          }
          source.close?.();
          if (activeMaskSource) activeMaskBounds = await readMaskBounds(activeMaskSource);
        } catch (error) {
          photoNaturalWidth = preview?.naturalWidth || 0;
          photoNaturalHeight = preview?.naturalHeight || 0;
          if (compositeConfig.mode === 'orientation') setCompositeAsset(compositeConfig.defaultKey);
        }
      };

      const getPhotoBaseSize = (mode = photoFit) => {
        const aspect = photoNaturalWidth > 0 && photoNaturalHeight > 0 ? photoNaturalWidth / photoNaturalHeight : 1;
        if (mode === 'fit') {
          return aspect >= 1 ? { width: 1, height: 1 / aspect } : { width: aspect, height: 1 };
        }
        return aspect >= 1 ? { width: aspect, height: 1 } : { width: 1, height: 1 / aspect };
      };

      const getMaskProjection = () => {
        const bounds = activeMaskBounds;
        const angle = (rotation * Math.PI) / 180;
        const cosine = Math.cos(angle);
        const sine = Math.sin(angle);
        const corners = [
          [bounds.left - .5, bounds.top - .5],
          [bounds.right - .5, bounds.top - .5],
          [bounds.right - .5, bounds.bottom - .5],
          [bounds.left - .5, bounds.bottom - .5]
        ];
        const projectedU = corners.map(([x, y]) => (x * cosine) + (y * sine));
        const projectedV = corners.map(([x, y]) => (-x * sine) + (y * cosine));
        return {
          cosine,
          sine,
          minU: Math.min(...projectedU),
          maxU: Math.max(...projectedU),
          minV: Math.min(...projectedV),
          maxV: Math.max(...projectedV)
        };
      };

      const getMinimumFillZoom = () => {
        if (!photoNaturalWidth || !photoNaturalHeight) return 100;
        const base = getPhotoBaseSize('fill');
        const projection = getMaskProjection();
        const required = Math.max(
          (projection.maxU - projection.minU) / Math.max(base.width, .001),
          (projection.maxV - projection.minV) / Math.max(base.height, .001)
        );
        return clamp(required * 101, 60, 300);
      };

      const getMinimumAllowedZoom = () => photoFit === 'fill' ? getMinimumFillZoom() : 60;

      const constrainPhotoTransform = () => {
        if (photoFit !== 'fill' || !photoNaturalWidth || !photoNaturalHeight) return;
        zoom = clamp(zoom, getMinimumFillZoom(), 300);
        const base = getPhotoBaseSize('fill');
        const width = base.width * (zoom / 100);
        const height = base.height * (zoom / 100);
        const projection = getMaskProjection();
        const currentX = photoX / 100;
        const currentY = photoY / 100;
        let translatedU = (currentX * projection.cosine) + (currentY * projection.sine);
        let translatedV = (-currentX * projection.sine) + (currentY * projection.cosine);
        translatedU = clamp(translatedU, projection.maxU - (width / 2), projection.minU + (width / 2));
        translatedV = clamp(translatedV, projection.maxV - (height / 2), projection.minV + (height / 2));
        photoX = clamp((translatedU * projection.cosine) - (translatedV * projection.sine), -1, 1) * 100;
        photoY = clamp((translatedU * projection.sine) + (translatedV * projection.cosine), -1, 1) * 100;
      };

      const updateImageTransform = () => {
        constrainPhotoTransform();
        [preview, editorPhoto].filter(Boolean).forEach((image) => {
          image.style.setProperty('--cp-zoom', String(zoom / 100));
          image.style.setProperty('--cp-rotation', `${rotation}deg`);
          image.style.setProperty('--cp-x', String(photoX));
          image.style.setProperty('--cp-y', String(photoY));
          image.style.setProperty('--cp-photo-fit', photoFit === 'fit' ? 'contain' : 'cover');
        });
        root.querySelectorAll('[data-photo-fit]').forEach((button) => {
          button.setAttribute('aria-pressed', String(button.dataset.photoFit === photoFit));
        });
        const property = root.querySelector('[data-photo-edit-property]');
        if (property) property.value = `Mode ${photoFit === 'fit' ? 'Show full photo' : 'Fill shape'}; layout ${compositeAssetKey}; zoom ${Math.round(zoom)}%, rotation ${Math.round(rotation)}deg, position X ${photoX.toFixed(1)}%, Y ${photoY.toFixed(1)}%`;
        if (photoFitProperty) photoFitProperty.value = photoFit === 'fit' ? 'Show full photo' : 'Fill shape';
        if (previewLayoutProperty) previewLayoutProperty.value = compositeAssetKey;
        const zoomInputNode = root.querySelector('[data-editor-zoom]');
        const rotationInputNode = root.querySelector('[data-editor-rotation]');
        const zoomOutputNode = root.querySelector('[data-editor-zoom-output]');
        const rotationOutputNode = root.querySelector('[data-editor-rotation-output]');
        if (zoomInputNode) {
          zoomInputNode.min = String(getMinimumAllowedZoom());
          zoomInputNode.value = String(zoom);
        }
        if (rotationInputNode) rotationInputNode.value = String(rotation);
        if (zoomOutputNode) zoomOutputNode.value = `${Math.round(zoom)}%`;
        if (rotationOutputNode) rotationOutputNode.value = `${Math.round(rotation)}°`;
        invalidateAdjustedPreview();
      };

      const updateTotals = () => {
        updateSizeCards();
        const variant = resolveVariant();
        const base = Number(variant?.price || 0);
        const baseCompare = Number(variant?.compare_at_price || 0);
        if (variantInput && variant) variantInput.value = variant.id;
        if (selectedOptionsProperty && variant) selectedOptionsProperty.value = variant.title;
        if (selectedVariantLabel) selectedVariantLabel.textContent = variant ? variant.title : strings.unavailable;
        syncCompositeForVariant(variant);
        if (!isComposite && variant?.image && !photoInput?.files?.length && !restoredPhotoSource && preview) {
          preview.src = variant.image;
          preview.hidden = false;
          if (placeholder) placeholder.hidden = true;
        }
        let total = base;
        let compare = Math.max(baseCompare, base);
        selectedExtras().forEach((node) => {
          const price = Number(node.dataset.priceCents || 0);
          const original = Number(node.dataset.compareCents || 0);
          total += price;
          compare += Math.max(price, original);
        });
        root.querySelectorAll('[data-total]').forEach((node) => { node.textContent = formatMoney(total); });
        root.querySelectorAll('[data-saved]').forEach((node) => { node.textContent = formatMoney(Math.max(0, compare - total)); });
        root.querySelectorAll('[data-purchase-button]').forEach((button) => {
          button.disabled = busy || !variant?.available || (isFullEdit && !editRestoreReady);
          const label = button.querySelector('span');
          if (!label || busy) return;
          if (!variant?.available) label.textContent = strings.unavailable;
          else label.textContent = button.dataset.cartAction === 'checkout' ? checkoutActionLabel : cartActionLabel;
        });
      };

      const setAccessorySelection = (nextKey, updateUrl = true) => {
        const nextAccessory = accessoryProducts[nextKey];
        if (!nextAccessory?.variant?.id || nextKey === accessoryKey) return;
        accessoryKey = nextKey;
        activeAccessory = nextAccessory;
        personalizerProfile = nextAccessory.profile || personalizerProfile;
        root.dataset.personalizerProfile = personalizerProfile;
        root.dataset.activeProductTitle = nextAccessory.title || '';
        if (personalizerProfileProperty) personalizerProfileProperty.value = personalizerProfile;
        if (accessoryProductProperty) accessoryProductProperty.value = nextAccessory.title || '';
        if (variantInput) variantInput.value = nextAccessory.variant.id;
        if (selectedOptionsProperty) selectedOptionsProperty.value = nextAccessory.variant.title || 'Default Title';
        if (backLink && nextAccessory.url) backLink.href = nextAccessory.url;
        root.querySelectorAll('[data-accessory-kind]').forEach((button) => {
          const selected = button.dataset.accessoryKind === nextAccessory.kind;
          button.classList.toggle('is-active', selected);
          button.setAttribute('aria-pressed', String(selected));
        });
        root.querySelectorAll('[data-accessory-shape]').forEach((button) => {
          const selected = button.dataset.accessoryShape === nextAccessory.shape;
          button.classList.toggle('is-active', selected);
          button.setAttribute('aria-pressed', String(selected));
        });
        const titleNode = root.querySelector('[data-accessory-product-title]');
        const priceNode = root.querySelector('[data-accessory-product-price]');
        if (titleNode) titleNode.textContent = nextAccessory.title || '';
        if (priceNode) priceNode.textContent = formatMoney(nextAccessory.variant.price || 0);
        setCompositeAsset(nextAccessory.assetKey);
        updateImageTransform();
        updateTotals();
        if (status) status.textContent = '';
        if (updateUrl && nextAccessory.url && window.history?.replaceState) {
          const nextUrl = new URL(window.location.href);
          nextUrl.pathname = new URL(nextAccessory.url, window.location.origin).pathname;
          nextUrl.searchParams.set('view', 'crystal-personalizer');
          nextUrl.searchParams.delete('variant');
          window.history.replaceState({ accessory: nextKey }, '', `${nextUrl.pathname}${nextUrl.search}${nextUrl.hash}`);
        }
      };

      root.querySelectorAll('[data-accessory-kind]').forEach((button) => {
        button.addEventListener('click', () => {
          const shape = activeAccessory?.shape || 'heart';
          setAccessorySelection(`${button.dataset.accessoryKind}-${shape}`);
        });
      });
      root.querySelectorAll('[data-accessory-shape]').forEach((button) => {
        button.addEventListener('click', () => {
          const kind = activeAccessory?.kind || 'necklace';
          setAccessorySelection(`${kind}-${button.dataset.accessoryShape}`);
        });
      });

      photoInput?.addEventListener('change', async (event) => {
        const file = photoInput.files?.[0];
        if (!file) return;
        if (!['image/jpeg', 'image/png', 'image/webp'].includes(file.type)) {
          photoInput.value = '';
          if (status) status.textContent = strings.fileType;
          return;
        }
        if (file.size > 15 * 1024 * 1024) {
          photoInput.value = '';
          if (status) status.textContent = strings.fileTooLarge;
          return;
        }
        if (status) status.textContent = '';
        if (objectUrl) {
          decodedImageCache.delete(objectUrl);
          URL.revokeObjectURL(objectUrl);
        }
        restoredPhotoSource = '';
        objectUrl = URL.createObjectURL(file);
        photoFit = 'fit';
        zoom = 100;
        rotation = 0;
        photoX = 0;
        photoY = 0;
        await detectCompositeOrientation(file);
        if (preview) {
          preview.src = objectUrl;
          preview.hidden = false;
          preview.alt = file.name;
        }
        if (editorPhoto) {
          editorPhoto.src = objectUrl;
          editorPhoto.hidden = false;
        }
        if (placeholder) placeholder.hidden = true;
        if (photoName) photoName.textContent = file.name;
        const editorPreview = root.querySelector('[data-editor-preview]');
        if (editorPreview) editorPreview.style.backgroundImage = `url("${objectUrl}")`;
        root.classList.add('is-photo-ready');
        if (editPhotoButton) editPhotoButton.disabled = false;
        dialogSnapshot = null;
        updateImageTransform();
      });

      const photoDialog = root.querySelector('[data-photo-dialog]');
      editPhotoButton?.addEventListener('click', () => {
        if (isComposite && !photoInput?.files?.length && !restoredPhotoSource) return;
        const src = preview?.currentSrc || preview?.src;
        const editorPreview = root.querySelector('[data-editor-preview]');
        if (src && editorPreview) editorPreview.style.backgroundImage = `url("${src}")`;
        if (src && editorPhoto) editorPhoto.src = src;
        dialogSnapshot = { zoom, rotation, photoX, photoY, photoFit, compositeAssetKey };
        updateImageTransform();
        photoDialog?.showModal();
      });

      const zoomInput = root.querySelector('[data-editor-zoom]');
      const rotationInput = root.querySelector('[data-editor-rotation]');
      const syncEditor = () => {
        const editor = root.querySelector('[data-editor-preview]');
        zoom = clamp(Number(zoomInput?.value || zoom || 100), getMinimumAllowedZoom(), 300);
        rotation = clamp(Number(rotationInput?.value || rotation || 0), -180, 180);
        if (editor) {
          editor.style.setProperty('--editor-zoom', `${zoom}%`);
          editor.style.setProperty('--editor-rotation', `${rotation}deg`);
        }
        updateImageTransform();
      };
      zoomInput?.addEventListener('input', syncEditor);
      rotationInput?.addEventListener('input', syncEditor);
      root.querySelector('[data-editor-reset]')?.addEventListener('click', () => {
        zoom = 100;
        rotation = 0;
        photoX = 0;
        photoY = 0;
        if (zoomInput) zoomInput.value = '100';
        if (rotationInput) rotationInput.value = '0';
        syncEditor();
      });
      root.querySelectorAll('[data-editor-rotate]').forEach((button) => {
        button.addEventListener('click', () => {
          rotation = clamp(rotation + Number(button.dataset.editorRotate || 0), -180, 180);
          if (rotationInput) rotationInput.value = String(rotation);
          syncEditor();
        });
      });
      root.querySelectorAll('[data-editor-zoom-step]').forEach((button) => {
        button.addEventListener('click', () => {
          zoom = clamp(zoom + Number(button.dataset.editorZoomStep || 0), getMinimumAllowedZoom(), 300);
          if (zoomInput) zoomInput.value = String(zoom);
          syncEditor();
        });
      });
      root.querySelectorAll('[data-composite-layout]').forEach((button) => {
        button.addEventListener('click', () => setCompositeAsset(button.dataset.compositeLayout));
      });
      root.querySelectorAll('[data-photo-fit]').forEach((button) => {
        button.addEventListener('click', () => {
          photoFit = button.dataset.photoFit === 'fit' ? 'fit' : 'fill';
          zoom = 100;
          rotation = 0;
          photoX = 0;
          photoY = 0;
          updateImageTransform();
        });
      });
      root.querySelector('[data-editor-apply]')?.addEventListener('click', () => {
        photoDialog.returnValue = 'apply';
        dialogSnapshot = null;
        photoDialog?.close();
      });
      photoDialog?.addEventListener('close', () => {
        if (photoDialog.returnValue !== 'apply' && dialogSnapshot) {
          ({ zoom, rotation, photoX, photoY, photoFit } = dialogSnapshot);
          setCompositeAsset(dialogSnapshot.compositeAssetKey);
          updateImageTransform();
        }
        dialogSnapshot = null;
        photoDialog.returnValue = '';
      });

      const bindPhotoInteraction = (surface) => {
        if (!surface) return;
        const pointers = new Map();
        const touches = new Map();
        let dragOrigin = null;
        let pinchOrigin = null;
        let touchDragOrigin = null;
        let touchPinchOrigin = null;
        let maskContext = null;
        let maskWidth = 0;
        let maskHeight = 0;
        const maskSource = surface.dataset.compositeMaskSrc || surface.closest('[data-composite]')?.dataset.compositeMaskSrc || '';
        if (maskSource) {
          const maskImage = new Image();
          maskImage.crossOrigin = 'anonymous';
          maskImage.addEventListener('load', () => {
            try {
              const canvas = document.createElement('canvas');
              canvas.width = maskImage.naturalWidth || 1000;
              canvas.height = maskImage.naturalHeight || 1000;
              const context = canvas.getContext('2d', { willReadFrequently: true });
              context?.drawImage(maskImage, 0, 0, canvas.width, canvas.height);
              maskContext = context;
              maskWidth = canvas.width;
              maskHeight = canvas.height;
            } catch (error) {
              maskContext = null;
            }
          }, { once: true });
          maskImage.src = maskSource;
        }
        const isInsidePhotoWindow = (clientX, clientY) => {
          const photoWindow = surface.querySelector('[data-composite-photo-window]');
          if (!photoWindow) return true;
          const bounds = photoWindow.getBoundingClientRect();
          const normalizedX = (clientX - bounds.left) / Math.max(bounds.width, 1);
          const normalizedY = (clientY - bounds.top) / Math.max(bounds.height, 1);
          if (normalizedX < 0 || normalizedX > 1 || normalizedY < 0 || normalizedY > 1) return false;
          if (!maskContext || !maskWidth || !maskHeight) {
            return normalizedX >= .12 && normalizedX <= .88 && normalizedY >= .08 && normalizedY <= .9;
          }
          try {
            const pixelX = Math.min(maskWidth - 1, Math.max(0, Math.floor(normalizedX * maskWidth)));
            const pixelY = Math.min(maskHeight - 1, Math.max(0, Math.floor(normalizedY * maskHeight)));
            return maskContext.getImageData(pixelX, pixelY, 1, 1).data[3] > 24;
          } catch (error) {
            return normalizedX >= .12 && normalizedX <= .88 && normalizedY >= .08 && normalizedY <= .9;
          }
        };
        const pointDistance = (pointMap) => {
          const values = [...pointMap.values()];
          if (values.length < 2) return 0;
          return Math.hypot(values[0].x - values[1].x, values[0].y - values[1].y);
        };
        surface.addEventListener('pointerdown', (event) => {
          if (event.pointerType === 'touch' || !root.classList.contains('is-photo-ready') || event.target.closest('button, label, input, [data-engraving-preview]') || !isInsidePhotoWindow(event.clientX, event.clientY)) return;
          event.preventDefault();
          surface.setPointerCapture?.(event.pointerId);
          pointers.set(event.pointerId, { x: event.clientX, y: event.clientY });
          if (pointers.size === 1) {
            dragOrigin = { x: event.clientX, y: event.clientY, photoX, photoY };
            pinchOrigin = null;
          } else if (pointers.size === 2) {
            pinchOrigin = { distance: pointDistance(pointers), zoom };
            dragOrigin = null;
          }
        });
        surface.addEventListener('pointermove', (event) => {
          if (!pointers.has(event.pointerId)) return;
          event.preventDefault();
          pointers.set(event.pointerId, { x: event.clientX, y: event.clientY });
          if (pointers.size >= 2 && pinchOrigin?.distance) {
            zoom = clamp(pinchOrigin.zoom * (pointDistance(pointers) / pinchOrigin.distance), getMinimumAllowedZoom(), 300);
            if (zoomInput) zoomInput.value = String(zoom);
            updateImageTransform();
            return;
          }
          if (pointers.size === 1 && dragOrigin) {
            const bounds = surface.getBoundingClientRect();
            photoX = clamp(dragOrigin.photoX + ((event.clientX - dragOrigin.x) / Math.max(bounds.width, 1)) * 100, -100, 100);
            photoY = clamp(dragOrigin.photoY + ((event.clientY - dragOrigin.y) / Math.max(bounds.height, 1)) * 100, -100, 100);
            updateImageTransform();
          }
        });
        const endPointer = (event) => {
          pointers.delete(event.pointerId);
          if (pointers.size === 1) {
            const remaining = [...pointers.values()][0];
            dragOrigin = { x: remaining.x, y: remaining.y, photoX, photoY };
            pinchOrigin = null;
          } else if (!pointers.size) {
            dragOrigin = null;
            pinchOrigin = null;
          }
        };
        surface.addEventListener('pointerup', endPointer);
        surface.addEventListener('pointercancel', endPointer);
        surface.addEventListener('touchstart', (event) => {
          const firstTouch = event.changedTouches[0];
          if (!firstTouch || !root.classList.contains('is-photo-ready') || event.target.closest('button, label, input, [data-engraving-preview]') || (!touches.size && !isInsidePhotoWindow(firstTouch.clientX, firstTouch.clientY))) return;
          event.preventDefault();
          Array.from(event.changedTouches).forEach((touch) => touches.set(touch.identifier, { x: touch.clientX, y: touch.clientY }));
          if (touches.size === 1) {
            touchDragOrigin = { x: firstTouch.clientX, y: firstTouch.clientY, photoX, photoY };
            touchPinchOrigin = null;
          } else if (touches.size >= 2) {
            touchPinchOrigin = { distance: pointDistance(touches), zoom };
            touchDragOrigin = null;
          }
        }, { passive: false });
        surface.addEventListener('touchmove', (event) => {
          if (!touches.size) return;
          event.preventDefault();
          Array.from(event.changedTouches).forEach((touch) => {
            if (touches.has(touch.identifier)) touches.set(touch.identifier, { x: touch.clientX, y: touch.clientY });
          });
          if (touches.size >= 2 && touchPinchOrigin?.distance) {
            zoom = clamp(touchPinchOrigin.zoom * (pointDistance(touches) / touchPinchOrigin.distance), getMinimumAllowedZoom(), 300);
            if (zoomInput) zoomInput.value = String(zoom);
            updateImageTransform();
            return;
          }
          if (touches.size === 1 && touchDragOrigin) {
            const current = [...touches.values()][0];
            const bounds = surface.getBoundingClientRect();
            photoX = clamp(touchDragOrigin.photoX + ((current.x - touchDragOrigin.x) / Math.max(bounds.width, 1)) * 100, -100, 100);
            photoY = clamp(touchDragOrigin.photoY + ((current.y - touchDragOrigin.y) / Math.max(bounds.height, 1)) * 100, -100, 100);
            updateImageTransform();
          }
        }, { passive: false });
        const endTouch = (event) => {
          Array.from(event.changedTouches).forEach((touch) => touches.delete(touch.identifier));
          if (touches.size === 1) {
            const remaining = [...touches.values()][0];
            touchDragOrigin = { x: remaining.x, y: remaining.y, photoX, photoY };
            touchPinchOrigin = null;
          } else if (!touches.size) {
            touchDragOrigin = null;
            touchPinchOrigin = null;
          }
        };
        surface.addEventListener('touchend', endTouch);
        surface.addEventListener('touchcancel', endTouch);
        surface.addEventListener('wheel', (event) => {
          if (!root.classList.contains('is-photo-ready') || !isInsidePhotoWindow(event.clientX, event.clientY)) return;
          event.preventDefault();
          zoom = clamp(zoom - event.deltaY * 0.08, getMinimumAllowedZoom(), 300);
          if (zoomInput) zoomInput.value = String(zoom);
          updateImageTransform();
        }, { passive: false });
      };
      root.querySelectorAll('[data-photo-interaction-surface]').forEach(bindPhotoInteraction);

      root.querySelector('[data-open-size-guide]')?.addEventListener('click', () => root.querySelector('[data-size-dialog]')?.showModal());

      const lightBaseInfoTrigger = root.querySelector('[data-open-light-base-info]');
      const lightBaseInfoDialog = root.querySelector('[data-light-base-info-dialog]');
      lightBaseInfoTrigger?.addEventListener('click', () => lightBaseInfoDialog?.showModal());
      lightBaseInfoDialog?.querySelectorAll('[data-close-light-base-info]').forEach((button) => {
        button.addEventListener('click', () => lightBaseInfoDialog.close());
      });
      lightBaseInfoDialog?.addEventListener('click', (event) => {
        if (event.target === lightBaseInfoDialog) lightBaseInfoDialog.close();
      });
      lightBaseInfoDialog?.addEventListener('close', () => lightBaseInfoTrigger?.focus({ preventScroll: true }));

      const importantDialog = root.querySelector('[data-important-dialog]');
      root.querySelector('[data-open-important]')?.addEventListener('click', () => importantDialog?.showModal());
      importantDialog?.querySelectorAll('[data-close-important]').forEach((button) => {
        button.addEventListener('click', () => importantDialog.close());
      });
      importantDialog?.addEventListener('click', (event) => {
        if (event.target === importantDialog) importantDialog.close();
      });

      const featureInputById = (featureId) => [...root.querySelectorAll('[data-feature]')]
        .find((input) => input.dataset.featureId === featureId);

      root.querySelectorAll('[data-feature-carousel]').forEach((carousel) => {
        const slides = [...carousel.querySelectorAll('[data-feature-carousel-slide]')];
        const dots = [...carousel.querySelectorAll('[data-feature-carousel-dot]')];
        let activeSlide = 0;
        const renderCarousel = () => {
          if (!slides.length) return;
          activeSlide = (activeSlide + slides.length) % slides.length;
          slides.forEach((slide, index) => { slide.hidden = index !== activeSlide; });
          dots.forEach((dot, index) => {
            const active = index === activeSlide;
            dot.classList.toggle('is-active', active);
            dot.setAttribute('aria-pressed', String(active));
          });
        };
        carousel.querySelectorAll('[data-feature-carousel-step]').forEach((button) => {
          button.addEventListener('click', () => {
            activeSlide += Number(button.dataset.featureCarouselStep || 0);
            renderCarousel();
          });
        });
        dots.forEach((dot) => {
          dot.addEventListener('click', () => {
            activeSlide = Number(dot.dataset.featureCarouselDot || 0);
            renderCarousel();
          });
        });
        renderCarousel();
      });

      root.querySelectorAll('[data-feature-dialog]').forEach((dialog) => {
        dialog.querySelectorAll('[data-close-feature-dialog]').forEach((button) => {
          button.addEventListener('click', () => dialog.close());
        });
        dialog.querySelector('[data-apply-feature]')?.addEventListener('click', (event) => {
          const input = featureInputById(event.currentTarget.dataset.applyFeature);
          if (!input || input.disabled) return;
          input.checked = true;
          input.dispatchEvent(new Event('change', { bubbles: true }));
          dialog.close();
        });
        dialog.addEventListener('click', (event) => {
          if (event.target === dialog) dialog.close();
        });
        dialog.addEventListener('close', () => {
          dialog.querySelectorAll('video').forEach((video) => video.pause());
        });
      });

      root.querySelectorAll('[data-open-feature-info]').forEach((button) => {
        button.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopPropagation();
          const dialog = document.getElementById(button.dataset.openFeatureInfo);
          if (!dialog) return;
          const applyButton = dialog.querySelector('[data-apply-feature]');
          const input = featureInputById(dialog.dataset.featureId);
          if (applyButton) {
            const isSelected = Boolean(input?.checked);
            applyButton.disabled = !input || input.disabled || isSelected;
            applyButton.textContent = isSelected
              ? applyButton.dataset.selectedLabel || 'Applied'
              : applyButton.dataset.defaultLabel || 'Apply';
          }
          dialog.showModal();
        });
      });

      root.querySelectorAll('[data-dimension-unit]').forEach((button) => {
        button.addEventListener('click', () => setDimensionUnit(button.dataset.dimensionUnit));
      });
      root.querySelectorAll('[data-product-option]').forEach((input) => input.addEventListener('change', () => {
        syncOptionAvailability();
        updateTotals();
      }));

      const syncFeatureState = (input) => {
        const key = input.dataset.featureKey;
        if (key === 'text') {
          const wrap = input.closest('.cp__feature-wrap');
          const panel = wrap?.querySelector('[data-engraving-panel]');
          if (panel) panel.hidden = !input.checked;
          wrap?.querySelectorAll('[data-engraving-control]').forEach((control) => { control.disabled = !input.checked; });
          updateEngravingPreview();
        }
        if (key === 'background') root.classList.toggle('is-background-kept', input.checked);
        if (key === 'ultra_hd') root.classList.toggle('is-ultra-hd', input.checked);
      };
      root.querySelectorAll('[data-feature]').forEach((input) => {
        input.addEventListener('change', () => {
          syncFeatureState(input);
          updateTotals();
        });
      });

      const engravingText = root.querySelector('[data-engraving-text]');
      const engravingFont = root.querySelector('[data-engraving-font]');
      const engravingFeature = root.querySelector('[data-feature-key="text"]');
      const engravingSizeInput = root.querySelector('[data-engraving-size]');
      const engravingXInput = root.querySelector('[data-engraving-x]');
      const engravingYInput = root.querySelector('[data-engraving-y]');
      const engravingFontFamilies = {
        Georgia: "Georgia, 'Times New Roman', serif",
        Arial: "Arial, Helvetica, sans-serif",
        'Times New Roman': "'Times New Roman', Times, serif",
        'Brush Script MT': "'Brush Script MT', 'Segoe Script', cursive"
      };
      const updateEngravingPreview = () => {
        if (!engravingText || !engravingFont) return;
        const selectedFont = engravingFont.value || 'Georgia';
        engravingText.style.fontFamily = engravingFontFamilies[selectedFont] || engravingFontFamilies.Georgia;
        engravingText.dataset.previewFont = selectedFont;
        const text = engravingText.value.trim();
        const size = clamp(Number(engravingSizeInput?.value || 32), 14, 72);
        const x = clamp(Number(engravingXInput?.value || 0), -38, 38);
        const y = clamp(Number(engravingYInput?.value || 0), -38, 38);
        root.querySelectorAll('[data-engraving-preview]').forEach((node) => {
          node.textContent = text;
          node.hidden = !engravingFeature?.checked || !text;
          node.style.fontFamily = engravingFontFamilies[selectedFont] || engravingFontFamilies.Georgia;
          node.style.setProperty('--engraving-size', String(size));
          node.style.setProperty('--engraving-x', String(x));
          node.style.setProperty('--engraving-y', String(y));
        });
        const sizeOutput = root.querySelector('[data-engraving-size-output]');
        const xOutput = root.querySelector('[data-engraving-x-output]');
        const yOutput = root.querySelector('[data-engraving-y-output]');
        if (sizeOutput) sizeOutput.value = String(size);
        if (xOutput) xOutput.value = `${x}%`;
        if (yOutput) yOutput.value = `${y}%`;
        invalidateAdjustedPreview();
      };
      engravingFont?.addEventListener('change', updateEngravingPreview);
      [engravingSizeInput, engravingXInput, engravingYInput].filter(Boolean).forEach((input) => input.addEventListener('input', updateEngravingPreview));
      updateEngravingPreview();
      engravingText?.addEventListener('input', () => {
        const count = root.querySelector('[data-character-count]');
        if (count) count.textContent = String(engravingText.value.length);
        updateEngravingPreview();
      });

      root.querySelectorAll('[data-engraving-preview]').forEach((overlay) => {
        let textDrag = null;
        overlay.addEventListener('pointerdown', (event) => {
          if (overlay.hidden || !engravingFeature?.checked) return;
          event.preventDefault();
          event.stopPropagation();
          overlay.setPointerCapture?.(event.pointerId);
          textDrag = {
            pointerId: event.pointerId,
            x: event.clientX,
            y: event.clientY,
            startX: Number(engravingXInput?.value || 0),
            startY: Number(engravingYInput?.value || 0)
          };
        });
        overlay.addEventListener('pointermove', (event) => {
          if (!textDrag || textDrag.pointerId !== event.pointerId) return;
          event.preventDefault();
          event.stopPropagation();
          engravingPositionTouched = true;
          const bounds = overlay.parentElement.getBoundingClientRect();
          if (engravingXInput) engravingXInput.value = String(Math.round(clamp(textDrag.startX + ((event.clientX - textDrag.x) / Math.max(bounds.width, 1)) * 100, -38, 38)));
          if (engravingYInput) engravingYInput.value = String(Math.round(clamp(textDrag.startY + ((event.clientY - textDrag.y) / Math.max(bounds.height, 1)) * 100, -38, 38)));
          updateEngravingPreview();
        });
        const endTextDrag = (event) => {
          if (textDrag?.pointerId === event.pointerId) textDrag = null;
        };
        overlay.addEventListener('pointerup', endTextDrag);
        overlay.addEventListener('pointercancel', endTextDrag);
      });


      const accessoryPhotoDialog = root.querySelector('[data-accessory-photo-dialog]');
      const accessoryPhotoInput = root.querySelector('[data-accessory-photo-input]');
      const accessoryPhotoDrafts = new Map();
      let accessoryEditorState = null;
      let accessoryEditorObjectUrl = '';
      let accessoryEditorDrag = null;

      const accessoryProfileForCard = (card) => {
        const handle = String(card?.dataset.productHandle || '').trim().toLowerCase();
        const profilesByHandle = {
          'necklace-heart-3d': 'accessory-necklace-heart',
          'necklace-rectang-3d': 'accessory-necklace-rectangle',
          'keychain-heart-3d': 'accessory-keychain-heart',
          'keychain-rectangle-3d': 'accessory-keychain-rectangle'
        };
        if (profilesByHandle[handle]) return profilesByHandle[handle];
        const title = String(card?.dataset.title || '').trim().toLowerCase();
        if (title.includes('necklace') && title.includes('heart')) return 'accessory-necklace-heart';
        if (title.includes('necklace') && (title.includes('rectangle') || title.includes('rectang'))) return 'accessory-necklace-rectangle';
        if (title.includes('keychain') && title.includes('heart')) return 'accessory-keychain-heart';
        if (title.includes('keychain') && (title.includes('rectangle') || title.includes('rectang'))) return 'accessory-keychain-rectangle';
        return '';
      };

      const accessoryTransformationValue = (state) => {
        const fitLabel = state?.fit === 'fit' ? 'Fit entire photo' : 'Fill shape';
        return 'Mode ' + fitLabel +
          ', zoom ' + Math.round(state?.zoom || 100) + '%' +
          ', rotation ' + Math.round(state?.rotation || 0) + 'deg' +
          ', position X ' + Math.round(state?.x || 0) + '%' +
          ', Y ' + Math.round(state?.y || 0) + '%';
      };

      const currentMainPhotoSource = () => {
        const file = photoInput?.files?.[0] || null;
        if (file) return { file, url: '' };
        return { file: null, url: restoredPhotoSource || '' };
      };

      const releaseAccessoryEditorObjectUrl = () => {
        if (!accessoryEditorObjectUrl) return;
        URL.revokeObjectURL(accessoryEditorObjectUrl);
        accessoryEditorObjectUrl = '';
      };

      const setAccessoryEditorSource = (file, url) => {
        releaseAccessoryEditorObjectUrl();
        if (file) accessoryEditorObjectUrl = URL.createObjectURL(file);
        if (accessoryEditorState) {
          accessoryEditorState.sourceFile = file || null;
          accessoryEditorState.sourceUrl = file ? '' : (url || '');
          accessoryEditorState.previewUrl = accessoryEditorObjectUrl || url || '';
        }
      };

      const renderAccessoryEditor = () => {
        const state = accessoryEditorState;
        if (!state || !accessoryPhotoDialog) return;
        const base = accessoryPhotoDialog.querySelector('[data-accessory-editor-base]');
        const windowNode = accessoryPhotoDialog.querySelector('[data-accessory-editor-window]');
        const image = accessoryPhotoDialog.querySelector('[data-accessory-editor-photo]');
        const overlay = accessoryPhotoDialog.querySelector('[data-accessory-editor-overlay]');
        const help = accessoryPhotoDialog.querySelector('[data-accessory-editor-help]');
        if (base) base.src = state.assets.base;
        if (overlay) overlay.src = state.assets.overlay;
        if (windowNode) windowNode.style.setProperty('--cp-photo-mask', 'url("' + state.assets.mask + '")');
        if (image) {
          if (state.previewUrl) {
            image.src = state.previewUrl;
            image.hidden = false;
          } else {
            image.removeAttribute('src');
            image.hidden = true;
          }
          image.style.setProperty('--cp-photo-fit', state.fit === 'fit' ? 'contain' : 'cover');
          image.style.setProperty('--cp-zoom', String(clamp(state.zoom, 60, 300) / 100));
          image.style.setProperty('--cp-rotation', clamp(state.rotation, -180, 180) + 'deg');
          image.style.setProperty('--cp-x', String(clamp(state.x, -60, 60)));
          image.style.setProperty('--cp-y', String(clamp(state.y, -60, 60)));
        }
        if (help) {
          help.textContent = state.previewUrl
            ? 'Use the main crystal photo, or choose a different photo. Drag to reposition.'
            : 'Upload a photo to personalize this crystal accessory.';
        }
        accessoryPhotoDialog.querySelectorAll('[data-accessory-photo-fit]').forEach((button) => {
          button.setAttribute('aria-pressed', String(button.dataset.accessoryPhotoFit === state.fit));
        });
        const zoomOutput = accessoryPhotoDialog.querySelector('[data-accessory-editor-zoom-output]');
        const rotationOutput = accessoryPhotoDialog.querySelector('[data-accessory-editor-rotation-output]');
        if (zoomOutput) zoomOutput.value = Math.round(state.zoom) + '%';
        if (rotationOutput) rotationOutput.value = Math.round(state.rotation) + '°';
      };

      const openAccessoryPhotoEditor = (card) => {
        if (!accessoryPhotoDialog) return false;
        const profile = accessoryProfileForCard(card);
        const assets = accessoryEditorAssets?.[profile];
        if (!profile || !assets?.base || !assets?.mask || !assets?.overlay) {
          if (status) status.textContent = 'This accessory photo outline is not configured yet.';
          return false;
        }
        const mainSource = currentMainPhotoSource();
        const initial = {
          sourceFile: mainSource.file,
          sourceUrl: mainSource.url,
          fit: photoFit,
          zoom,
          rotation,
          x: photoX,
          y: photoY
        };
        accessoryEditorState = {
          card,
          profile,
          assets,
          uploadedFile: null,
          sourceFile: initial.sourceFile,
          sourceUrl: initial.sourceUrl,
          previewUrl: '',
          fit: initial.fit,
          zoom: initial.zoom,
          rotation: initial.rotation,
          x: initial.x,
          y: initial.y,
          initial
        };
        accessoryEditorState.initialTransformation = accessoryTransformationValue(accessoryEditorState);
        setAccessoryEditorSource(initial.sourceFile, initial.sourceUrl);
        if (accessoryPhotoInput) accessoryPhotoInput.value = '';
        const title = accessoryPhotoDialog.querySelector('[data-accessory-editor-title]');
        const error = accessoryPhotoDialog.querySelector('[data-accessory-photo-error]');
        if (title) title.textContent = 'Edit Photo · ' + (card.dataset.title || 'Crystal Accessory');
        if (error) error.textContent = '';
        accessoryPhotoDialog.returnValue = '';
        renderAccessoryEditor();
        accessoryPhotoDialog.showModal();
        return true;
      };

      accessoryPhotoInput?.addEventListener('change', () => {
        const file = accessoryPhotoInput.files?.[0];
        if (!file || !accessoryEditorState) return;
        const error = accessoryPhotoDialog?.querySelector('[data-accessory-photo-error]');
        if (!['image/jpeg', 'image/png', 'image/webp'].includes(file.type)) {
          accessoryPhotoInput.value = '';
          if (error) error.textContent = strings.fileType;
          return;
        }
        if (file.size > 15 * 1024 * 1024) {
          accessoryPhotoInput.value = '';
          if (error) error.textContent = strings.fileTooLarge;
          return;
        }
        if (error) error.textContent = '';
        accessoryEditorState.uploadedFile = file;
        accessoryEditorState.fit = 'fill';
        accessoryEditorState.zoom = 100;
        accessoryEditorState.rotation = 0;
        accessoryEditorState.x = 0;
        accessoryEditorState.y = 0;
        setAccessoryEditorSource(file, '');
        renderAccessoryEditor();
      });

      accessoryPhotoDialog?.querySelectorAll('[data-accessory-photo-fit]').forEach((button) => {
        button.addEventListener('click', () => {
          if (!accessoryEditorState) return;
          accessoryEditorState.fit = button.dataset.accessoryPhotoFit === 'fit' ? 'fit' : 'fill';
          accessoryEditorState.zoom = 100;
          accessoryEditorState.rotation = 0;
          accessoryEditorState.x = 0;
          accessoryEditorState.y = 0;
          renderAccessoryEditor();
        });
      });

      accessoryPhotoDialog?.querySelectorAll('[data-accessory-editor-rotate]').forEach((button) => {
        button.addEventListener('click', () => {
          if (!accessoryEditorState) return;
          accessoryEditorState.rotation = clamp(
            accessoryEditorState.rotation + Number(button.dataset.accessoryEditorRotate || 0),
            -180,
            180
          );
          renderAccessoryEditor();
        });
      });

      accessoryPhotoDialog?.querySelectorAll('[data-accessory-editor-zoom-step]').forEach((button) => {
        button.addEventListener('click', () => {
          if (!accessoryEditorState) return;
          accessoryEditorState.zoom = clamp(
            accessoryEditorState.zoom + Number(button.dataset.accessoryEditorZoomStep || 0),
            60,
            300
          );
          renderAccessoryEditor();
        });
      });

      accessoryPhotoDialog?.querySelector('[data-accessory-editor-reset]')?.addEventListener('click', () => {
        if (!accessoryEditorState) return;
        const initial = accessoryEditorState.initial;
        accessoryEditorState.uploadedFile = null;
        accessoryEditorState.fit = initial.fit;
        accessoryEditorState.zoom = initial.zoom;
        accessoryEditorState.rotation = initial.rotation;
        accessoryEditorState.x = initial.x;
        accessoryEditorState.y = initial.y;
        if (accessoryPhotoInput) accessoryPhotoInput.value = '';
        setAccessoryEditorSource(initial.sourceFile, initial.sourceUrl);
        const error = accessoryPhotoDialog.querySelector('[data-accessory-photo-error]');
        if (error) error.textContent = '';
        renderAccessoryEditor();
      });

      const accessoryEditorWindow = accessoryPhotoDialog?.querySelector('[data-accessory-editor-window]');
      accessoryEditorWindow?.addEventListener('pointerdown', (event) => {
        if (!accessoryEditorState?.previewUrl) return;
        const bounds = accessoryEditorWindow.getBoundingClientRect();
        accessoryEditorDrag = {
          pointerId: event.pointerId,
          startX: event.clientX,
          startY: event.clientY,
          originX: accessoryEditorState.x,
          originY: accessoryEditorState.y,
          width: Math.max(bounds.width, 1),
          height: Math.max(bounds.height, 1)
        };
        accessoryEditorWindow.setPointerCapture?.(event.pointerId);
        event.preventDefault();
      });
      accessoryEditorWindow?.addEventListener('pointermove', (event) => {
        if (!accessoryEditorDrag || event.pointerId !== accessoryEditorDrag.pointerId || !accessoryEditorState) return;
        accessoryEditorState.x = clamp(
          accessoryEditorDrag.originX + ((event.clientX - accessoryEditorDrag.startX) / accessoryEditorDrag.width) * 100,
          -60,
          60
        );
        accessoryEditorState.y = clamp(
          accessoryEditorDrag.originY + ((event.clientY - accessoryEditorDrag.startY) / accessoryEditorDrag.height) * 100,
          -60,
          60
        );
        renderAccessoryEditor();
      });
      const finishAccessoryEditorDrag = (event) => {
        if (accessoryEditorDrag?.pointerId === event.pointerId) accessoryEditorDrag = null;
      };
      accessoryEditorWindow?.addEventListener('pointerup', finishAccessoryEditorDrag);
      accessoryEditorWindow?.addEventListener('pointercancel', finishAccessoryEditorDrag);
      accessoryEditorWindow?.addEventListener('wheel', (event) => {
        if (!accessoryEditorState?.previewUrl) return;
        event.preventDefault();
        accessoryEditorState.zoom = clamp(accessoryEditorState.zoom + (event.deltaY < 0 ? 5 : -5), 60, 300);
        renderAccessoryEditor();
      }, { passive: false });

      accessoryPhotoDialog?.querySelector('[data-accessory-editor-apply]')?.addEventListener('click', () => {
        const state = accessoryEditorState;
        const error = accessoryPhotoDialog.querySelector('[data-accessory-photo-error]');
        if (!state?.sourceFile && !state?.sourceUrl) {
          if (error) error.textContent = 'Upload a photo before applying this accessory.';
          return;
        }
        const isCustom = Boolean(
          state.uploadedFile ||
          accessoryTransformationValue(state) !== state.initialTransformation
        );
        accessoryPhotoDrafts.set(state.card, {
          profile: state.profile,
          assets: { ...state.assets },
          mode: isCustom ? 'custom' : 'synced',
          sourceFile: state.sourceFile || null,
          sourceUrl: state.sourceUrl || '',
          fit: state.fit,
          zoom: state.zoom,
          rotation: state.rotation,
          x: state.x,
          y: state.y
        });
        state.card.classList.add('is-selected');
        state.card.setAttribute('aria-pressed', 'true');
        const action = state.card.querySelector('[data-addon-action]');
        if (action) action.textContent = strings.added;
        updateTotals();
        accessoryPhotoDialog.returnValue = 'apply';
        accessoryPhotoDialog.close();
      });

      accessoryPhotoDialog?.addEventListener('close', () => {
        releaseAccessoryEditorObjectUrl();
        accessoryEditorState = null;
        accessoryEditorDrag = null;
        if (accessoryPhotoInput) accessoryPhotoInput.value = '';
        accessoryPhotoDialog.returnValue = '';
      });

      root.querySelectorAll('[data-addon]').forEach((card) => {
        card.addEventListener('click', () => {
          if (card.disabled || card.dataset.configured !== 'true' || card.dataset.available === 'false') return;
          const selected = card.classList.contains('is-selected');
          if (card.dataset.group === 'accessory') {
            if (!selected) {
              openAccessoryPhotoEditor(card);
              return;
            }
            accessoryPhotoDrafts.delete(card);
          }
          if (card.dataset.mode === 'single') {
            root.querySelectorAll(`[data-addon][data-group="${card.dataset.group}"]`).forEach((peer) => {
              peer.classList.remove('is-selected');
              peer.setAttribute('aria-pressed', 'false');
              const peerLabel = peer.querySelector('[data-addon-action]');
              if (peerLabel) peerLabel.textContent = strings.add;
            });
            if (selected && !card.classList.contains('cp__addon-card--none')) {
              const noneCard = root.querySelector(`[data-addon][data-group="${card.dataset.group}"].cp__addon-card--none`);
              noneCard?.classList.add('is-selected');
              noneCard?.setAttribute('aria-pressed', 'true');
            } else {
              card.classList.add('is-selected');
              card.setAttribute('aria-pressed', 'true');
            }
          } else {
            card.classList.toggle('is-selected', !selected);
            card.setAttribute('aria-pressed', String(!selected));
          }
          const action = card.querySelector('[data-addon-action]');
          if (action) action.textContent = card.classList.contains('is-selected') ? strings.added : strings.add;
          updateTotals();
        });
      });

      root.querySelectorAll('[data-filters]').forEach((filterRow) => {
        filterRow.addEventListener('click', (event) => {
          const button = event.target.closest('[data-filter]');
          if (!button) return;
          const group = filterRow.dataset.filters;
          filterRow.querySelectorAll('[data-filter]').forEach((item) => item.classList.toggle('is-active', item === button));
          root.querySelectorAll(`[data-addon][data-group="${group}"]`).forEach((card) => {
            card.hidden = button.dataset.filter !== 'all' && card.dataset.category !== button.dataset.filter;
          });
        });
      });

      const selectedAddonCards = () => [...root.querySelectorAll('[data-addon].is-selected')]
        .filter((node) => !node.classList.contains('cp__addon-card--none') && node.dataset.configured === 'true' && node.dataset.available !== 'false');
      const addonPropertyNames = {
        light_base: 'Light base',
        accessory: 'Crystal accessories',
        personalization: 'Additional portraits',
        wrapping: 'Gift wrapping',
        card: 'Greeting card',
        video_book: 'Video book'
      };
      const appendConfigurationProperties = (formData) => {
        const grouped = new Map();
        selectedAddonCards().forEach((node) => {
          const group = node.dataset.group || 'other';
          const title = node.dataset.title || node.querySelector('.cp__addon-copy strong')?.textContent?.trim() || 'Selected add-on';
          if (!grouped.has(group)) grouped.set(group, []);
          grouped.get(group).push(title);
        });
        grouped.forEach((titles, group) => {
          formData.append(`properties[${addonPropertyNames[group] || 'Other add-ons'}]`, titles.join(', '));
        });
        const allAddons = [...grouped.values()].flat();
        if (allAddons.length) formData.append('properties[Selected add-ons]', allAddons.join(' · '));
        const services = [...root.querySelectorAll('[data-feature]:checked')]
          .map((node) => node.dataset.title || node.value)
          .filter(Boolean);
        if (services.length) formData.append('properties[Selected services]', services.join(' · '));
      };

      function loadImageSource(src) {
        return new Promise((resolve, reject) => {
          const image = new Image();
          if (/^(https?:)?\/\//i.test(src)) image.crossOrigin = 'anonymous';
          const timeout = window.setTimeout(() => {
            image.src = '';
            reject(new Error('image-timeout'));
          }, 12000);
          image.onload = () => {
            window.clearTimeout(timeout);
            resolve(image);
          };
          image.onerror = (error) => {
            window.clearTimeout(timeout);
            reject(error);
          };
          image.src = src;
        });
      }
      function loadImageSourceCached(src) {
        if (!src) return Promise.reject(new Error('missing-image-source'));
        if (decodedImageCache.has(src)) return decodedImageCache.get(src);
        const request = loadImageSource(src).catch((error) => {
          decodedImageCache.delete(src);
          throw error;
        });
        decodedImageCache.set(src, request);
        return request;
      }
      function warmCompositeAssets(asset) {
        if (!asset) return;
        Promise.allSettled([asset.base, asset.mask, asset.overlay].filter(Boolean).map(loadImageSourceCached));
      }
      function canvasBlob(canvas, type = 'image/webp', quality = 0.82) {
        return new Promise((resolve, reject) => {
          canvas.toBlob((blob) => blob ? resolve(blob) : reject(new Error('preview-blob')), type, quality);
        });
      }

      async function createAccessoryAdjustedPreviewFile(draft, fallbackUrl = '') {
        if (!draft?.assets?.base || !draft?.assets?.mask || !draft?.assets?.overlay) {
          throw new Error('This accessory photo outline is not configured.');
        }
        let temporarySourceUrl = '';
        try {
          if (draft.sourceFile) temporarySourceUrl = URL.createObjectURL(draft.sourceFile);
          const sourceUrl = temporarySourceUrl || draft.sourceUrl || fallbackUrl;
          if (!sourceUrl) throw new Error('The accessory photo is unavailable.');
          const [baseImage, maskImage, overlayImage, photoImage] = await Promise.all([
            loadImageSource(draft.assets.base),
            loadImageSource(draft.assets.mask),
            loadImageSource(draft.assets.overlay),
            loadImageSource(sourceUrl)
          ]);
          const size = 1200;
          const output = document.createElement('canvas');
          output.width = size;
          output.height = size;
          const outputContext = output.getContext('2d');
          outputContext.drawImage(baseImage, 0, 0, size, size);

          const processed = document.createElement('canvas');
          processed.width = size;
          processed.height = size;
          const photoContext = processed.getContext('2d');
          const photoWidth = photoImage.naturalWidth || photoImage.width || 1;
          const photoHeight = photoImage.naturalHeight || photoImage.height || 1;
          const baseScale = draft.fit === 'fit'
            ? Math.min(size / photoWidth, size / photoHeight)
            : Math.max(size / photoWidth, size / photoHeight);
          const drawWidth = photoWidth * baseScale;
          const drawHeight = photoHeight * baseScale;
          photoContext.save();
          photoContext.translate(
            size / 2 + (Number(draft.x || 0) / 100) * size,
            size / 2 + (Number(draft.y || 0) / 100) * size
          );
          photoContext.rotate((Number(draft.rotation || 0) * Math.PI) / 180);
          photoContext.scale(Number(draft.zoom || 100) / 100, Number(draft.zoom || 100) / 100);
          photoContext.filter = 'grayscale(1) contrast(1.08)';
          photoContext.drawImage(photoImage, -drawWidth / 2, -drawHeight / 2, drawWidth, drawHeight);
          photoContext.restore();
          photoContext.filter = 'none';
          photoContext.globalCompositeOperation = 'destination-in';
          photoContext.drawImage(maskImage, 0, 0, size, size);
          photoContext.globalCompositeOperation = 'source-over';
          outputContext.drawImage(processed, 0, 0);
          outputContext.drawImage(overlayImage, 0, 0, size, size);
          const blob = await canvasBlob(output, 'image/png', 0.94);
          const sourceName = draft.sourceFile?.name || 'main-crystal-photo';
          const safeName = (sourceName.replace(/\.[^.]+$/, '') || 'photo').replace(/[^a-z0-9_-]+/gi, '-');
          return new File([blob], safeName + '-' + draft.profile + '-preview.png', { type: 'image/png' });
        } finally {
          if (temporarySourceUrl) URL.revokeObjectURL(temporarySourceUrl);
        }
      }

      async function addStagedAccessoryPhotoItem(entry, originalPhotoReference) {
        const sourceDraft = entry.draft || {};
        const mainSource = currentMainPhotoSource();
        const draft = sourceDraft.mode === 'synced'
          ? {
              ...sourceDraft,
              sourceFile: mainSource.file,
              sourceUrl: mainSource.url || originalPhotoReference,
              fit: photoFit,
              zoom,
              rotation,
              x: photoX,
              y: photoY
            }
          : sourceDraft;
        const originalPhoto = draft.mode === 'synced'
          ? originalPhotoReference
          : (draft.sourceUrl || originalPhotoReference);
        if (!draft.sourceFile && !draft.sourceUrl && !originalPhotoReference) {
          throw new Error('The accessory photo is unavailable.');
        }

        const previewFile = await createAccessoryAdjustedPreviewFile(draft, originalPhotoReference);
        const properties = { ...(entry.item.properties || {}) };
        [
          'Original photo',
          '_Original photo',
          'Adjusted preview',
          '_Adjusted preview',
          'Photo transformation',
          'Photo fit',
          'Preview layout',
          'Personalizer profile',
          '_Accessory photo profile',
          '_Accessory photo mode',
          '_Accessory photo override'
        ].forEach((key) => delete properties[key]);
        properties['_Accessory photo mode'] = draft.mode === 'custom' ? 'custom' : 'synced';
        if (draft.mode === 'custom') properties['_Accessory photo override'] = 'true';
        properties['Personalizer profile'] = draft.profile;
        properties['_Accessory photo profile'] = draft.profile;
        properties['Photo transformation'] = accessoryTransformationValue(draft);
        properties['Photo fit'] = draft.fit === 'fit' ? 'Fit entire photo' : 'Fill shape';
        properties['Preview layout'] = 'default';
        properties['_Photo source configuration'] = properties['_Configuration ID'] || '';

        const formData = new FormData();
        formData.append('id', String(entry.item.id));
        formData.append('quantity', String(entry.item.quantity));
        Object.entries(properties).forEach(([key, value]) => {
          if (value != null && value !== '') formData.append('properties[' + key + ']', String(value));
        });
        if (draft.mode === 'custom' && draft.sourceFile) {
          formData.append('properties[Original photo]', draft.sourceFile, draft.sourceFile.name);
        } else {
          const originalValue = originalPhoto || draft.sourceUrl;
          if (!originalValue) throw new Error('The accessory photo is unavailable.');
          formData.append('properties[Original photo]', originalValue);
        }
        formData.append('properties[Adjusted preview]', previewFile, previewFile.name);

        const response = await fetch(routesRoot + 'cart/add.js', {
          method: 'POST',
          headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: formData
        });
        const added = await response.json().catch(() => ({}));
        if (!response.ok || added.errors) {
          throw new Error(added.description || 'The accessory photo could not be added.');
        }

        if (added?.key && added?.properties) {
          const normalized = { ...(added.properties || {}) };
          normalized['_Original photo'] = normalized['Original photo'] || originalPhoto || draft.sourceUrl || '';
          normalized['_Adjusted preview'] = normalized['Adjusted preview'] || '';
          try {
            const normalizeResponse = await fetch(routesRoot + 'cart/change.js', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
                'X-Requested-With': 'XMLHttpRequest'
              },
              body: JSON.stringify({
                id: added.key,
                quantity: Number(added.quantity || entry.item.quantity || 1),
                properties: normalized
              })
            });
            if (!normalizeResponse.ok) console.warn('[ArtLaser3D personalizer] Accessory photo metadata could not be normalized.');
          } catch (normalizeError) {
            console.warn('[ArtLaser3D personalizer] Accessory photo metadata could not be normalized.', normalizeError);
          }
        }
        return added;
      }

      function adjustedPreviewSignature() {
        const file = photoInput?.files?.[0];
        const source = file
          ? `file:${file.name}:${file.size}:${file.lastModified}:${objectUrl}`
          : restoredPhotoSource ? `url:${restoredPhotoSource}` : '';
        if (!source || !isComposite || !composite) return '';
        const engravingTextNode = root.querySelector('[data-engraving-text]');
        const engravingFontNode = root.querySelector('[data-engraving-font]');
        const engravingFeatureNode = root.querySelector('[data-feature-key="text"]');
        return JSON.stringify({
          source,
          profile: personalizerProfile,
          layout: compositeAssetKey,
          base: composite.dataset.compositeBaseSrc || '',
          mask: composite.dataset.compositeMaskSrc || '',
          overlay: composite.dataset.compositeOverlaySrc || '',
          fit: photoFit,
          zoom: Number(zoom).toFixed(2),
          rotation: Number(rotation).toFixed(2),
          x: Number(photoX).toFixed(2),
          y: Number(photoY).toFixed(2),
          engraving: Boolean(engravingFeatureNode?.checked),
          text: engravingTextNode?.value || '',
          font: engravingFontNode?.value || 'Georgia',
          size: root.querySelector('[data-engraving-size]')?.value || '32',
          engravingX: root.querySelector('[data-engraving-x]')?.value || '0',
          engravingY: root.querySelector('[data-engraving-y]')?.value || '0'
        });
      }
      function scheduleAdjustedPreviewWarmup(delay = 420) {
        window.clearTimeout(adjustedPreviewWarmupTimer);
        adjustedPreviewWarmupTimer = 0;
        if (busy || !adjustedPreviewSignature()) return;
        adjustedPreviewWarmupTimer = window.setTimeout(() => {
          adjustedPreviewWarmupTimer = 0;
          const warm = () => { getAdjustedPreviewFile().catch(() => null); };
          if ('requestIdleCallback' in window) window.requestIdleCallback(warm, { timeout: 900 });
          else warm();
        }, delay);
      }
      function invalidateAdjustedPreview(options = {}) {
        adjustedPreviewGeneration += 1;
        adjustedPreviewCache = { signature: '', file: null, promise: null };
        delete root.dataset.adjustedPreviewReady;
        delete root.dataset.adjustedPreviewType;
        window.clearTimeout(adjustedPreviewWarmupTimer);
        adjustedPreviewWarmupTimer = 0;
        if (options.warm !== false) scheduleAdjustedPreviewWarmup(options.delay);
      }
      function getAdjustedPreviewFile() {
        const signature = adjustedPreviewSignature();
        if (!signature) return Promise.resolve(null);
        if (adjustedPreviewCache.signature === signature) {
          if (adjustedPreviewCache.file) return Promise.resolve(adjustedPreviewCache.file);
          if (adjustedPreviewCache.promise) return adjustedPreviewCache.promise;
        }
        const generation = ++adjustedPreviewGeneration;
        const promise = createAdjustedPreviewFile().then((file) => {
          if (generation === adjustedPreviewGeneration && adjustedPreviewSignature() === signature) {
            adjustedPreviewCache = { signature, file, promise: null };
            root.dataset.adjustedPreviewReady = String(Boolean(file));
            root.dataset.adjustedPreviewType = file?.type || '';
            window.__agAdjustedPreviewDebug = file ? { bytes: file.size, type: file.type, cachedAt: Date.now() } : null;
            if (performanceDebug && file) console.debug('[ArtLaser3D personalizer performance] preview-warmed', window.__agAdjustedPreviewDebug);
          }
          return file;
        }).catch((error) => {
          if (generation === adjustedPreviewGeneration) adjustedPreviewCache = { signature: '', file: null, promise: null };
          throw error;
        });
        adjustedPreviewCache = { signature, file: null, promise };
        return promise;
      }
      const wrapCanvasText = (context, value, maxWidth) => value.split('\n').flatMap((paragraph) => {
        if (!paragraph) return [''];
        const units = paragraph.includes(' ') ? paragraph.split(/\s+/) : [...paragraph];
        const separator = paragraph.includes(' ') ? ' ' : '';
        const lines = [];
        let line = '';
        units.forEach((unit) => {
          const candidate = line ? `${line}${separator}${unit}` : unit;
          if (line && context.measureText(candidate).width > maxWidth) {
            lines.push(line);
            line = unit;
          } else {
            line = candidate;
          }
        });
        if (line) lines.push(line);
        return lines;
      });
      const createAdjustedPreviewFile = async () => {
        const file = photoInput?.files?.[0];
        const photoSource = file || restoredPhotoSource;
        if (!photoSource || !isComposite || !composite) return null;
        const photoSourceUrl = file ? objectUrl : restoredPhotoSource;
        const [baseImage, maskImage, overlayImage, photoImage] = await Promise.all([
          loadImageSourceCached(composite.dataset.compositeBaseSrc),
          loadImageSourceCached(composite.dataset.compositeMaskSrc),
          loadImageSourceCached(composite.dataset.compositeOverlaySrc),
          loadImageSourceCached(photoSourceUrl)
        ]);
        const size = 1000;
        const output = document.createElement('canvas');
        output.width = size;
        output.height = size;
        const outputContext = output.getContext('2d');
        outputContext.drawImage(baseImage, 0, 0, size, size);

        const processed = document.createElement('canvas');
        processed.width = size;
        processed.height = size;
        const photoContext = processed.getContext('2d');
        const photoWidth = photoImage.naturalWidth || photoImage.width;
        const photoHeight = photoImage.naturalHeight || photoImage.height;
        const baseScale = photoFit === 'fit'
          ? Math.min(size / photoWidth, size / photoHeight)
          : Math.max(size / photoWidth, size / photoHeight);
        const drawWidth = photoWidth * baseScale;
        const drawHeight = photoHeight * baseScale;
        photoContext.save();
        photoContext.translate(size / 2 + (photoX / 100) * size, size / 2 + (photoY / 100) * size);
        photoContext.rotate((rotation * Math.PI) / 180);
        photoContext.scale(zoom / 100, zoom / 100);
        photoContext.filter = 'grayscale(1) contrast(1.08)';
        photoContext.drawImage(photoImage, -drawWidth / 2, -drawHeight / 2, drawWidth, drawHeight);
        photoContext.restore();
        photoContext.filter = 'none';
        if (engravingFeature?.checked && engravingText?.value.trim()) {
          const engravingSize = clamp(Number(engravingSizeInput?.value || 32), 14, 72) * (size / 620);
          const engravingX = clamp(Number(engravingXInput?.value || 0), -38, 38);
          const engravingY = clamp(Number(engravingYInput?.value || 0), -38, 38);
          const selectedFont = engravingFont?.value || 'Georgia';
          const fontFamily = engravingFontFamilies[selectedFont] || engravingFontFamilies.Georgia;
          photoContext.save();
          photoContext.font = `600 ${engravingSize}px ${fontFamily}`;
          photoContext.textAlign = 'center';
          photoContext.textBaseline = 'middle';
          photoContext.fillStyle = 'rgba(250,250,250,.92)';
          photoContext.strokeStyle = 'rgba(8,14,26,.72)';
          photoContext.lineWidth = Math.max(1, engravingSize * .035);
          photoContext.shadowColor = 'rgba(255,255,255,.35)';
          photoContext.shadowBlur = engravingSize * .15;
          const lines = wrapCanvasText(photoContext, engravingText.value.trim(), size * .62);
          const lineHeight = engravingSize * 1.16;
          const startY = size / 2 + (engravingY / 100) * size - ((lines.length - 1) * lineHeight) / 2;
          const textX = size / 2 + (engravingX / 100) * size;
          lines.forEach((line, index) => {
            const textY = startY + index * lineHeight;
            photoContext.strokeText(line, textX, textY, size * .62);
            photoContext.fillText(line, textX, textY, size * .62);
          });
          photoContext.restore();
        }
        photoContext.globalCompositeOperation = 'destination-in';
        photoContext.drawImage(maskImage, 0, 0, size, size);
        photoContext.globalCompositeOperation = 'source-over';

        outputContext.drawImage(processed, 0, 0);
        outputContext.drawImage(overlayImage, 0, 0, size, size);
        const blob = await canvasBlob(output).catch(() => canvasBlob(output, 'image/png'));
        const sourceName = file?.name || restoredPhotoSource.split('/').pop()?.split('?')[0] || 'restored-photo';
        const safeName = (sourceName.replace(/\.[^.]+$/, '') || 'photo').replace(/[^a-z0-9_-]+/gi, '-');
        const extension = blob.type === 'image/webp' ? 'webp' : 'png';
        return new File([blob], `${safeName}-${personalizerProfile}-${compositeAssetKey}-preview.${extension}`, { type: blob.type || 'image/png' });
      };

      const createConfigurationId = () => {
        if (window.crypto?.randomUUID) return window.crypto.randomUUID();
        return `cp-${Date.now()}-${Math.random().toString(36).slice(2, 10)}`;
      };

      const normalizedItemTypeForNode = (node) => {
        const group = String(node.dataset.group || '').toLowerCase();
        if (group === 'light_base') return 'Light base';
        if (group === 'accessory') return 'Crystal accessory';
        if (group === 'card') return 'Greeting card';
        return node.dataset.itemKind || 'Add-on';
      };

      const customAccessoryPhotoPropertyKeys = [
        'Original photo',
        '_Original photo',
        'Adjusted preview',
        '_Adjusted preview',
        'Photo transformation',
        'Photo fit',
        'Personalizer profile',
        'Preview layout',
        '_Accessory photo profile',
        '_Accessory photo mode',
        '_Accessory photo override',
        '_Photo source configuration'
      ];
      const accessoryPhotoIsCustom = (properties = {}) => {
        const mode = String(properties['_Accessory photo mode'] || '').trim().toLowerCase();
        const override = String(properties['_Accessory photo override'] || '').trim().toLowerCase();
        return mode === 'custom' || ['true', 'yes', '1', 'on'].includes(override);
      };
      const copyCustomAccessoryPhotoProperties = (target, source = {}) => {
        customAccessoryPhotoPropertyKeys.forEach((key) => {
          const value = source[key];
          if (value != null && value !== '') target[key] = value;
        });
      };

      const preserveSnapshotProperties = (formData, properties) => {
        const excluded = new Set([
          '_Item type',
          '_Parent line key',
          '_Copy source variant',
          '_Full edit replacement token',
          '_Configuration revision',
          'Selected add-ons',
          'Selected services',
          'Light base',
          'Crystal accessories',
          'Greeting card',
          'Gift wrapping',
          'Video book',
          'Engraving text',
          'Engraving font',
          'Engraving size',
          'Engraving position X',
          'Engraving position Y',
          ...[...root.querySelectorAll('[data-feature]')].map((feature) => feature.dataset.title || '').filter(Boolean)
        ]);
        Object.entries(properties || {}).forEach(([key, value]) => {
          if (excluded.has(key) || value == null || value === '') return;
          const formKey = `properties[${key}]`;
          const currentValue = formData.get(formKey);
          const emptyFile = currentValue instanceof File && currentValue.size === 0;
          if (!formData.has(formKey) || currentValue === '' || emptyFile) formData.set(formKey, String(value));
        });
      };

      const copyPersonalizationProperties = (source) => {
        const excluded = new Set([
          '_Item type',
          '_Parent line key',
          '_Copy source variant',
          '_Photo replacement token',
          '_Full edit replacement token',
          '_Configuration revision',
          'Selected add-ons',
          'Light base',
          'Crystal accessories',
          'Greeting card',
          'Gift wrapping',
          'Video book'
        ]);
        const properties = {};
        Object.entries(source || {}).forEach(([key, value]) => {
          if (!excluded.has(key) && value != null && value !== '') properties[key] = value;
        });
        return properties;
      };

      const propertyIsEnabled = (value) => {
        const normalized = String(value ?? '').trim().toLowerCase();
        return Boolean(normalized) && !['false', 'no', '0', 'off', 'none'].includes(normalized);
      };
      const parsePhotoTransformation = (properties = {}) => {
        const transformation = String(properties['Photo transformation'] || '');
        const numberFrom = (pattern, fallback) => {
          const match = transformation.match(pattern);
          const value = Number(match?.[1]);
          return Number.isFinite(value) ? value : fallback;
        };
        const fitValue = String(properties['Photo fit'] || '');
        const layoutMatch = transformation.match(/layout\s+([^;,]+)/i);
        return {
          fit: /fill/i.test(fitValue || transformation) ? 'fill' : 'fit',
          layout: String(properties['Preview layout'] || layoutMatch?.[1] || '').trim(),
          zoom: numberFrom(/zoom\s+(-?[\d.]+)%/i, 100),
          rotation: numberFrom(/rotation\s+(-?[\d.]+)deg/i, 0),
          x: numberFrom(/position\s+X\s+(-?[\d.]+)%/i, 0),
          y: numberFrom(/(?:position\s+)?Y\s+(-?[\d.]+)%/i, 0)
        };
      };

      const restoreEditSnapshot = async () => {
        if (!isFullEdit || !editSnapshot?.items?.length) return false;
        const mainItem = editSnapshot.items.find((item) => !item.properties?.['_Item type']);
        if (!mainItem) return false;
        const mainProperties = mainItem.properties || {};
        const snapshotVariant = variants.find((variant) => String(variant.id) === String(mainItem?.variant_id || ''));
        if (snapshotVariant) {
          snapshotVariant.options?.forEach((optionValue, index) => {
            const option = [...root.querySelectorAll('[data-product-option]')].find((input) =>
              Number(input.dataset.optionPosition) === index + 1 && String(input.value) === String(optionValue)
            );
            if (option) option.checked = true;
          });
          if (variantInput) variantInput.value = snapshotVariant.id;
        }

        Object.entries(mainProperties).forEach(([key, value]) => {
          const field = form?.elements?.namedItem(`properties[${key}]`);
          if (!field || value == null) return;
          if (field instanceof RadioNodeList) field.value = String(value);
          else if (field.type === 'checkbox') field.checked = propertyIsEnabled(value);
          else if (field.type !== 'file') field.value = String(value);
        });

        const selectedVariantIds = new Set(
          editSnapshot.items
            .filter((item) => item.properties?.['_Item type'] && String(item.properties?.['_Item type']).toLowerCase() !== 'copy')
            .map((item) => String(item.variant_id))
        );
        root.querySelectorAll('[data-addon]').forEach((card) => {
          if (card.classList.contains('cp__addon-card--none')) return;
          card.classList.remove('is-selected');
          card.setAttribute('aria-pressed', 'false');
          const action = card.querySelector('[data-addon-action]');
          if (action) action.textContent = strings.add;
        });
        root.querySelectorAll('[data-addon]').forEach((card) => {
          if (!selectedVariantIds.has(String(card.dataset.variantId || ''))) return;
          if (card.dataset.mode === 'single') {
            root.querySelectorAll(`[data-addon][data-group="${card.dataset.group}"]`).forEach((peer) => {
              peer.classList.remove('is-selected');
              peer.setAttribute('aria-pressed', 'false');
            });
          }
          card.classList.add('is-selected');
          card.setAttribute('aria-pressed', 'true');
          const action = card.querySelector('[data-addon-action]');
          if (action) action.textContent = strings.added;
        });

        const selectedServiceTitles = new Set(
          String(mainProperties['Selected services'] || '')
            .split(/\s*[·,]\s*/)
            .map((title) => title.trim())
            .filter(Boolean)
        );
        root.querySelectorAll('[data-feature]').forEach((feature) => {
          const title = feature.dataset.title || '';
          const selected = selectedVariantIds.has(String(feature.dataset.variantId || '')) ||
            propertyIsEnabled(mainProperties[title]) ||
            selectedServiceTitles.has(title);
          feature.checked = selected;
          syncFeatureState(feature);
        });

        const photoState = parsePhotoTransformation(mainProperties);
        photoFit = photoState.fit;
        zoom = clamp(photoState.zoom, 60, 300);
        rotation = clamp(photoState.rotation, -180, 180);
        photoX = clamp(photoState.x, -100, 100);
        photoY = clamp(photoState.y, -100, 100);
        if (photoState.layout && compositeConfig?.assets?.[photoState.layout]) compositeAssetKey = photoState.layout;
        if (zoomInput) zoomInput.value = String(zoom);
        if (rotationInput) rotationInput.value = String(rotation);
        engravingPositionTouched = mainProperties['Engraving position X'] != null || mainProperties['Engraving position Y'] != null;

        const originalPhoto = mainProperties['Original photo'] || '';
        const adjustedPreview = mainProperties['Adjusted preview'] || '';
        restoredPhotoSource = originalPhoto || adjustedPreview;
        if (restoredPhotoSource) {
          [preview, editorPhoto].filter(Boolean).forEach((image) => {
            image.src = restoredPhotoSource;
            image.hidden = false;
          });
          if (preview) preview.alt = 'Previously uploaded photo';
          if (placeholder) placeholder.hidden = true;
          if (photoName) photoName.textContent = 'Previously uploaded photo';
          const editorPreview = root.querySelector('[data-editor-preview]');
          if (editorPreview) editorPreview.style.backgroundImage = `url("${restoredPhotoSource}")`;
          root.classList.add('is-photo-ready');
          if (editPhotoButton) editPhotoButton.disabled = false;
          try {
            const restoredImage = await loadImageSource(restoredPhotoSource);
            photoNaturalWidth = restoredImage.naturalWidth || restoredImage.width || 0;
            photoNaturalHeight = restoredImage.naturalHeight || restoredImage.height || 0;
          } catch (error) {
            photoNaturalWidth = preview?.naturalWidth || 0;
            photoNaturalHeight = preview?.naturalHeight || 0;
          }
        }
        const count = root.querySelector('[data-character-count]');
        if (count && engravingText) count.textContent = String(engravingText.value.length);
        updateEngravingPreview();
        if (configurationInput) configurationInput.value = editConfigurationId;
        return true;
      };

      const setBusyState = (action, nextBusy) => {
        busy = nextBusy;
        root.querySelectorAll('[data-purchase-button]').forEach((button) => {
          button.disabled = nextBusy || !resolveVariant()?.available || (isFullEdit && !editRestoreReady);
          const label = button.querySelector('span');
          if (!label) return;
          if (nextBusy && button.dataset.cartAction === action) {
            label.textContent = action === 'checkout' ? checkoutBusyLabel : cartBusyLabel;
          } else if (!nextBusy) {
            label.textContent = button.dataset.cartAction === 'checkout' ? checkoutActionLabel : cartActionLabel;
          }
        });
      };

      const startCartPerformance = (action) => {
        cartPerformanceRun = {
          action,
          mode: isFullEdit ? 'full-edit' : 'new-configuration',
          startedAt: performance.now(),
          stages: []
        };
      };
      const setCartStage = (stage, message = '', details = {}) => {
        const elapsed = cartPerformanceRun ? Math.round(performance.now() - cartPerformanceRun.startedAt) : 0;
        root.dataset.cartStage = stage;
        if (message && status) status.textContent = message;
        if (cartPerformanceRun) cartPerformanceRun.stages.push({ stage, elapsed, ...details });
        document.dispatchEvent(new CustomEvent('personalizer:cart-stage', {
          detail: { stage, elapsed, mode: cartPerformanceRun?.mode || '', ...details }
        }));
        if (performanceDebug) console.debug('[ArtLaser3D personalizer performance]', stage, `${elapsed}ms`, details);
      };
      const finishCartPerformance = (outcome, details = {}) => {
        if (!cartPerformanceRun) return;
        const finishedAt = performance.now();
        cartPerformanceRun = {
          ...cartPerformanceRun,
          outcome,
          total: Math.round(finishedAt - cartPerformanceRun.startedAt),
          ...details
        };
        window.__agLastCartPerformance = cartPerformanceRun;
        root.dataset.cartStage = outcome;
        if (performanceDebug) console.info('[ArtLaser3D personalizer performance] complete', cartPerformanceRun);
      };

      form?.addEventListener('submit', async (event) => {
        event.preventDefault();
        const variant = resolveVariant();
        if (!variant?.available) {
          if (status) status.textContent = strings.unavailable;
          return;
        }
        if (isFullEdit && !editSnapshot?.items?.length) {
          if (status) status.textContent = 'This cart configuration could not be identified. Return to the cart and open Edit full configuration again.';
          return;
        }
        if (root.dataset.requirePhoto === 'true' && !photoInput?.files?.length && !isFullEdit) {
          if (status) status.textContent = strings.photoRequired;
          photoInput?.focus();
          return;
        }
        const action = event.submitter?.dataset.cartAction || 'cart';
        const configurationId = isFullEdit ? editConfigurationId : createConfigurationId();
        const revisionToken = isFullEdit ? `edit-${createConfigurationId()}` : '';
        const snapshotMainItem = isFullEdit ? editSnapshot.items.find((item) => !item.properties?.['_Item type']) : null;
        const snapshotCopyItems = isFullEdit
          ? editSnapshot.items.filter((item) => String(item.properties?.['_Item type'] || '').toLowerCase() === 'copy')
          : [];
        const snapshotCustomAccessoriesByVariant = new Map();
        if (isFullEdit) {
          editSnapshot.items.forEach((item) => {
            const properties = item.properties || {};
            const itemType = String(properties['_Item type'] || '').trim().toLowerCase();
            const addonGroup = String(properties['_Addon group'] || '').trim().toLowerCase();
            const productType = String(item.product_type || '').trim().toLowerCase();
            const isAccessory = addonGroup === 'accessory' || itemType.includes('crystal accessor') || productType === 'crystal accessories';
            if (!isAccessory || !accessoryPhotoIsCustom(properties)) return;
            const variantId = String(item.variant_id || '');
            if (!variantId) return;
            if (!snapshotCustomAccessoriesByVariant.has(variantId)) snapshotCustomAccessoriesByVariant.set(variantId, []);
            snapshotCustomAccessoriesByVariant.get(variantId).push(item);
          });
        }
        const mainQuantity = isFullEdit
          ? Math.max(1, editSnapshot.items.filter((item) => !item.properties?.['_Item type']).reduce((total, item) => total + Number(item.quantity || 0), 0))
          : 1;
        const variantChangedDuringEdit = isFullEdit && String(snapshotMainItem?.variant_id || '') !== String(variant.id);
        if (configurationInput) configurationInput.value = configurationId;
        if (selectedOptionsProperty) selectedOptionsProperty.value = variant.title;
        setBusyState(action, true);
        if (status) status.textContent = '';
        startCartPerformance(action);
        let mainAdded = false;
        let oldConfigurationRemoved = false;
        try {
          setCartStage('prepare-preview', 'Preparing your preview…');
          const mainFormData = new FormData(form);
          mainFormData.set('quantity', String(mainQuantity));
          if (isFullEdit) preserveSnapshotProperties(mainFormData, snapshotMainItem?.properties || {});
          if (revisionToken) mainFormData.set('properties[_Configuration revision]', revisionToken);
          appendConfigurationProperties(mainFormData);
          if (variantChangedDuringEdit) {
            mainFormData.delete('properties[Light base]');
            const removedBaseTitles = new Set(
              selectedAddonCards()
                .filter((node) => (node.dataset.group || '') === 'light_base')
                .map((node) => node.dataset.title || '')
                .filter(Boolean)
            );
            const selectedSummary = String(mainFormData.get('properties[Selected add-ons]') || '')
              .split(' · ')
              .filter((title) => title && !removedBaseTitles.has(title));
            if (selectedSummary.length) mainFormData.set('properties[Selected add-ons]', selectedSummary.join(' · '));
            else mainFormData.delete('properties[Selected add-ons]');
          }
          const previewSignature = adjustedPreviewSignature();
          const previewCacheHit = Boolean(previewSignature && adjustedPreviewCache.signature === previewSignature && adjustedPreviewCache.file);
          window.clearTimeout(adjustedPreviewWarmupTimer);
          adjustedPreviewWarmupTimer = 0;
          const adjustedPreview = await getAdjustedPreviewFile();
          if (adjustedPreview) mainFormData.set('properties[Adjusted preview]', adjustedPreview, adjustedPreview.name);
          setCartStage('upload-main', 'Uploading your personalization…', {
            previewBytes: adjustedPreview?.size || 0,
            originalBytes: photoInput?.files?.[0]?.size || 0,
            previewCacheHit,
            previewType: adjustedPreview?.type || ''
          });
          const mainResponse = await fetch(`${routesRoot}cart/add.js`, { method: 'POST', headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: mainFormData });
          if (!mainResponse.ok) throw new Error('main-item');
          const mainItem = await mainResponse.json().catch(() => null);
          mainAdded = true;
          if (!mainItem?.key) throw new Error('main-response');
          const mainProperties = mainItem?.properties || {};
          const originalPhotoReference = mainProperties['Original photo'] || '';
          const selectedAddonSummary = selectedAddonCards()
            .filter((node) => !(variantChangedDuringEdit && (node.dataset.group || '') === 'light_base'))
            .map((node) => node.dataset.title || '')
            .filter(Boolean)
            .join(' · ');
          const stagedAccessoryItems = [];
          const items = [...root.querySelectorAll('[data-feature]:checked, [data-addon].is-selected')]
            .filter((node) => node.dataset.configured === 'true' && node.dataset.available !== 'false')
            .filter((node) => !(variantChangedDuringEdit && (node.dataset.group || '') === 'light_base'))
            .map((node) => {
              const addonGroup = node.dataset.group || '';
              const isSamePhotoAccessory = addonGroup === 'accessory';
              const customAccessoryQueue = isSamePhotoAccessory
                ? snapshotCustomAccessoriesByVariant.get(String(node.dataset.variantId || ''))
                : null;
              const snapshotCustomAccessory = customAccessoryQueue?.shift() || null;
              const properties = {
                '_Configuration ID': configurationId,
                '_Parent product': root.dataset.activeProductTitle || document.title,
                '_Parent line key': mainItem.key,
                '_Item type': normalizedItemTypeForNode(node),
                '_Addon group': addonGroup,
                'Configured with': node.dataset.title || '',
                '_Parent selection summary': selectedAddonSummary
              };
              if (revisionToken) properties['_Configuration revision'] = revisionToken;
              if (['light_base', 'accessory', 'card'].includes(addonGroup)) properties['_Sync quantity'] = 'true';
              if (addonGroup === 'light_base') properties['_Compatible parent variant'] = String(variant.id);
              if (snapshotCustomAccessory) {
                copyCustomAccessoryPhotoProperties(properties, snapshotCustomAccessory.properties || {});
                properties['_Accessory photo mode'] = 'custom';
                properties['_Accessory photo override'] = 'true';
                properties['_Photo source configuration'] = configurationId;
              } else if (isSamePhotoAccessory && originalPhotoReference) {
                properties['_Original photo'] = originalPhotoReference;
                properties['_Photo source configuration'] = configurationId;
                properties['_Accessory photo mode'] = 'synced';
              }
              const item = { id: Number(node.dataset.variantId || 0), quantity: mainQuantity, properties };
              const accessoryDraft = isSamePhotoAccessory ? accessoryPhotoDrafts.get(node) : null;
              if (accessoryDraft) {
                stagedAccessoryItems.push({ item, draft: accessoryDraft });
                return null;
              }
              return item;
            })
            .filter((item) => item && item.id > 0);
          snapshotCopyItems.forEach((copyItem) => {
            const properties = copyPersonalizationProperties(mainProperties);
            properties['_Configuration ID'] = configurationId;
            properties['_Item type'] = 'Copy';
            properties['_Parent line key'] = mainItem?.key || '';
            properties['_Copy source variant'] = String(variant.id);
            properties['Configured with'] = root.dataset.activeProductTitle || document.title;
            if (revisionToken) properties['_Configuration revision'] = revisionToken;
            items.push({
              id: Number(copyItem.variant_id || 0),
              quantity: Math.max(1, Number(copyItem.quantity || 1)),
              properties
            });
          });
          if (items.length) {
            setCartStage('add-extras', 'Adding your selected extras…', { itemCount: items.length });
            const extrasResponse = await fetch(`${routesRoot}cart/add.js`, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: JSON.stringify({ items }) });
            if (!extrasResponse.ok) throw new Error('extras');
          }
          if (stagedAccessoryItems.length) {
            setCartStage('add-accessory-photos', 'Adding your crystal accessories…', { itemCount: stagedAccessoryItems.length });
            for (const entry of stagedAccessoryItems) {
              await addStagedAccessoryPhotoItem(entry, originalPhotoReference);
            }
          }
          if (!items.length && !stagedAccessoryItems.length) {
            setCartStage('add-extras-skipped', '', { itemCount: 0 });
          }
          if (isFullEdit) {
            setCartStage('replace-configuration', 'Saving your configuration…');
            const editCart = await fetch(`${routesRoot}cart.js`, { headers: { Accept: 'application/json' } }).then((response) => response.json());
            const updates = {};
            editCart.items.forEach((cartItem) => {
              const sameConfiguration = cartItem.properties?.['_Configuration ID'] === configurationId || cartItem.key === configurationId;
              const isReplacement = cartItem.properties?.['_Configuration revision'] === revisionToken;
              if (sameConfiguration && !isReplacement) updates[cartItem.key] = 0;
            });
            if (Object.keys(updates).length) {
              const removeResponse = await fetch(`${routesRoot}cart/update.js`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
                body: JSON.stringify({ updates })
              });
              if (!removeResponse.ok) throw new Error('replace-old-configuration');
            }
            oldConfigurationRemoved = true;
            try {
              sessionStorage.removeItem(`ag-full-edit:${configurationId}`);
              sessionStorage.setItem(
                'ag-cart-notice',
                variantChangedDuringEdit
                  ? 'Configuration updated. The previous light base was removed after the size changed; please choose a compatible base.'
                  : 'Configuration updated. Add-ons and any Copy now match the saved personalization.'
              );
            } catch (storageError) {
              // Saving the cart must not depend on browser storage.
            }
          }
          if (action === 'checkout') {
            setCartStage('open-checkout', 'Opening checkout…');
            finishCartPerformance('success');
            window.location.assign(`${routesRoot}checkout`);
            return;
          }
          if (root.dataset.redirectCart === 'true') {
            setCartStage('open-cart', 'Opening your cart…');
            finishCartPerformance('success');
            window.location.assign(`${routesRoot}cart`);
            return;
          }
          setCartStage('refresh-cart', 'Refreshing your cart…');
          const cart = await fetch(`${routesRoot}cart.js`, { headers: { Accept: 'application/json' } }).then((response) => response.ok ? response.json() : null).catch(() => null);
          document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart, source: 'crystal-personalizer' } }));
          if (status) status.textContent = strings.addedToCart;
          if (configurationInput) configurationInput.value = '';
          setBusyState(action, false);
          finishCartPerformance('success');
        } catch (error) {
          let originalConfigurationKept = false;
          if (isFullEdit && revisionToken && !oldConfigurationRemoved) {
            try {
              const rollbackCart = await fetch(`${routesRoot}cart.js`, { headers: { Accept: 'application/json' } }).then((response) => response.json());
              const rollbackUpdates = {};
              rollbackCart.items.forEach((item) => {
                if (item.properties?.['_Configuration revision'] === revisionToken) rollbackUpdates[item.key] = 0;
              });
              if (Object.keys(rollbackUpdates).length) {
                const rollbackResponse = await fetch(`${routesRoot}cart/update.js`, {
                  method: 'POST',
                  headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
                  body: JSON.stringify({ updates: rollbackUpdates })
                });
                originalConfigurationKept = rollbackResponse.ok;
              } else {
                originalConfigurationKept = true;
              }
            } catch (rollbackError) {
              originalConfigurationKept = false;
            }
          }
          if (status) {
            status.textContent = originalConfigurationKept
              ? 'We could not save the changes. Your original configuration is still in the cart.'
              : mainAdded ? strings.partialCartError : strings.cartError;
          }
          finishCartPerformance('error', { error: error?.message || 'cart-error' });
          setBusyState(action, false);
        }
      });

      const initializeState = async () => {
        if (isFullEdit) editSnapshot = await loadEditSnapshot();
        const restored = await restoreEditSnapshot();
        editRestoreReady = !isFullEdit || restored;
        root.removeAttribute('aria-busy');
        syncEditor();
        syncOptionAvailability();
        setCompositeAsset(compositeAssetKey);
        updateImageTransform();
        setDimensionUnit('in');
        updateTotals();
        if (isFullEdit && !restored) {
          if (status) status.textContent = 'This cart configuration is no longer available. Return to the cart and open the correct configuration again.';
          root.querySelectorAll('[data-purchase-button]').forEach((button) => { button.disabled = true; });
        }
      };
      initializeState().catch(() => {
        editRestoreReady = !isFullEdit;
        root.removeAttribute('aria-busy');
        if (status) status.textContent = isFullEdit
          ? 'We could not restore this cart configuration. Return to the cart and try again.'
          : strings.cartError;
        root.querySelectorAll('[data-purchase-button]').forEach((button) => { button.disabled = isFullEdit; });
      });
      window.addEventListener('pagehide', () => {
        window.clearTimeout(adjustedPreviewWarmupTimer);
        if (objectUrl) URL.revokeObjectURL(objectUrl);
      }, { once: true });
    };

    document.querySelectorAll('[data-crystal-personalizer]').forEach(init);
    document.addEventListener('shopify:section:load', (event) => init(event.target.querySelector('[data-crystal-personalizer]')));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size' || this.getAttribute('data-sticky-type') === 'attachment';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
